var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339,
    height: 333,
    viewBox: "0 0 339 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_379)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_379",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 339,
    height: 333
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M339 0H0V333H339V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_379)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.037,
    d: "M198.376 290.797C252.57 290.797 296.503 274.543 296.503 254.494C296.503 234.444 252.57 218.19 198.376 218.19C144.182 218.19 100.249 234.444 100.249 254.494C100.249 274.543 144.182 290.797 198.376 290.797Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.074,
    d: "M198.376 290.162C251.619 290.162 294.781 274.193 294.781 254.494C294.781 234.794 251.619 218.825 198.376 218.825C145.133 218.825 101.971 234.794 101.971 254.494C101.971 274.193 145.133 290.162 198.376 290.162Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.111,
    d: "M198.375 289.525C250.669 289.525 293.061 273.841 293.061 254.494C293.061 235.146 250.669 219.462 198.375 219.462C146.082 219.462 103.69 235.146 103.69 254.494C103.69 273.841 146.082 289.525 198.375 289.525Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.148,
    d: "M198.376 288.888C249.718 288.888 291.339 273.489 291.339 254.494C291.339 235.498 249.718 220.099 198.376 220.099C147.033 220.099 105.412 235.498 105.412 254.494C105.412 273.489 147.033 288.888 198.376 288.888Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.185,
    d: "M198.376 288.252C248.768 288.252 289.62 273.138 289.62 254.493C289.62 235.849 248.768 220.734 198.376 220.734C147.983 220.734 107.131 235.849 107.131 254.493C107.131 273.138 147.983 288.252 198.376 288.252Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.222,
    d: "M198.376 287.615C247.819 287.615 287.9 272.786 287.9 254.493C287.9 236.201 247.819 221.372 198.376 221.372C148.933 221.372 108.851 236.201 108.851 254.493C108.851 272.786 148.933 287.615 198.376 287.615Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.259,
    d: "M198.376 286.978C246.868 286.978 286.179 272.434 286.179 254.493C286.179 236.553 246.868 222.009 198.376 222.009C149.884 222.009 110.573 236.553 110.573 254.493C110.573 272.434 149.884 286.978 198.376 286.978Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.296,
    d: "M198.375 286.343C245.918 286.343 284.459 272.083 284.459 254.493C284.459 236.904 245.918 222.644 198.375 222.644C150.833 222.644 112.292 236.904 112.292 254.493C112.292 272.083 150.833 286.343 198.375 286.343Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "M198.375 285.706C244.967 285.706 282.737 271.732 282.737 254.493C282.737 237.255 244.967 223.281 198.375 223.281C151.784 223.281 114.014 237.255 114.014 254.493C114.014 271.732 151.784 285.706 198.375 285.706Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M198.376 285.069C244.018 285.069 281.018 271.38 281.018 254.493C281.018 237.607 244.018 223.918 198.376 223.918C152.734 223.918 115.733 237.607 115.733 254.493C115.733 271.38 152.734 285.069 198.376 285.069Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.407,
    d: "M198.376 284.429C243.067 284.429 279.296 271.026 279.296 254.491C279.296 237.957 243.067 224.554 198.376 224.554C153.684 224.554 117.455 237.957 117.455 254.491C117.455 271.026 153.684 284.429 198.376 284.429Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "M198.376 283.796C242.117 283.796 277.577 270.677 277.577 254.494C277.577 238.31 242.117 225.191 198.376 225.191C154.634 225.191 119.175 238.31 119.175 254.494C119.175 270.677 154.634 283.796 198.376 283.796Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.481,
    d: "M198.376 283.159C241.168 283.159 275.857 270.325 275.857 254.494C275.857 238.662 241.168 225.828 198.376 225.828C155.584 225.828 120.895 238.662 120.895 254.494C120.895 270.325 155.584 283.159 198.376 283.159Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.518,
    d: "M198.376 282.52C240.217 282.52 274.136 269.971 274.136 254.491C274.136 239.012 240.217 226.463 198.376 226.463C156.535 226.463 122.616 239.012 122.616 254.491C122.616 269.971 156.535 282.52 198.376 282.52Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556,
    d: "M198.376 281.887C239.267 281.887 272.416 269.622 272.416 254.493C272.416 239.365 239.267 227.1 198.376 227.1C157.484 227.1 124.335 239.365 124.335 254.493C124.335 269.622 157.484 281.887 198.376 281.887Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.593,
    d: "M198.376 281.249C238.316 281.249 270.694 269.27 270.694 254.493C270.694 239.717 238.316 227.737 198.376 227.737C158.435 227.737 126.057 239.717 126.057 254.493C126.057 269.27 158.435 281.249 198.376 281.249Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M198.376 280.612C237.366 280.612 268.975 268.918 268.975 254.493C268.975 240.068 237.366 228.375 198.376 228.375C159.385 228.375 127.777 240.068 127.777 254.493C127.777 268.918 159.385 280.612 198.376 280.612Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "M198.376 279.977C236.417 279.977 267.255 268.568 267.255 254.493C267.255 240.419 236.417 229.01 198.376 229.01C160.335 229.01 129.497 240.419 129.497 254.493C129.497 268.568 160.335 279.977 198.376 279.977Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.704,
    d: "M198.376 279.34C235.466 279.34 265.533 268.216 265.533 254.493C265.533 240.771 235.466 229.647 198.376 229.647C161.286 229.647 131.218 240.771 131.218 254.493C131.218 268.216 161.286 279.34 198.376 279.34Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.741,
    d: "M198.376 278.703C234.516 278.703 263.814 267.864 263.814 254.494C263.814 241.123 234.516 230.284 198.376 230.284C162.235 230.284 132.938 241.123 132.938 254.494C132.938 267.864 162.235 278.703 198.376 278.703Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.778,
    d: "M198.376 278.068C233.565 278.068 262.092 267.513 262.092 254.494C262.092 241.474 233.565 230.919 198.376 230.919C163.186 230.919 134.659 241.474 134.659 254.494C134.659 267.513 163.186 278.068 198.376 278.068Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.815,
    d: "M198.376 277.431C232.616 277.431 260.372 267.161 260.372 254.494C260.372 241.826 232.616 231.557 198.376 231.557C164.136 231.557 136.379 241.826 136.379 254.494C136.379 267.161 164.136 277.431 198.376 277.431Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.852,
    d: "M198.376 276.793C231.665 276.793 258.651 266.809 258.651 254.494C258.651 242.178 231.665 232.194 198.376 232.194C165.087 232.194 138.101 242.178 138.101 254.494C138.101 266.809 165.087 276.793 198.376 276.793Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.889,
    d: "M198.376 276.158C230.715 276.158 256.931 266.459 256.931 254.494C256.931 242.528 230.715 232.829 198.376 232.829C166.037 232.829 139.82 242.528 139.82 254.494C139.82 266.459 166.037 276.158 198.376 276.158Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.926,
    d: "M198.375 275.521C229.765 275.521 255.211 266.107 255.211 254.493C255.211 242.88 229.765 233.466 198.375 233.466C166.986 233.466 141.54 242.88 141.54 254.493C141.54 266.107 166.986 275.521 198.375 275.521Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.963,
    d: "M198.375 274.884C228.814 274.884 253.49 265.755 253.49 254.493C253.49 243.232 228.814 234.103 198.375 234.103C167.937 234.103 143.261 243.232 143.261 254.493C143.261 265.755 167.937 274.884 198.375 274.884Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.376 274.249C227.865 274.249 251.77 265.404 251.77 254.493C251.77 243.583 227.865 234.738 198.376 234.738C168.887 234.738 144.981 243.583 144.981 254.493C144.981 265.404 168.887 274.249 198.376 274.249Z",
    fill: "#141414"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.5316 208.334L195.883 278.926C197.771 280.015 199.915 280.584 202.096 280.575C204.276 280.567 206.415 279.98 208.295 278.876L279.907 236.675C280.835 236.13 281.604 235.351 282.137 234.416C282.67 233.481 282.948 232.423 282.944 231.347C282.939 230.271 282.653 229.215 282.113 228.284C281.573 227.354 280.798 226.581 279.865 226.043L159.182 156.424C156.942 155.132 154.4 154.457 151.814 154.467C149.228 154.477 146.691 155.172 144.462 156.482L73.4899 198.306C72.6154 198.821 71.8913 199.556 71.3897 200.438C70.888 201.32 70.6262 202.318 70.6304 203.332C70.6346 204.346 70.9047 205.342 71.4137 206.22C71.9227 207.097 72.6529 207.826 73.5316 208.334Z",
    fill: "url(#paint0_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5316 207.868L195.883 278.459C197.771 279.549 199.915 280.118 202.096 280.109C204.276 280.101 206.415 279.514 208.295 278.409L279.907 236.209C280.835 235.663 281.604 234.884 282.137 233.949C282.67 233.014 282.948 231.956 282.944 230.88C282.939 229.805 282.653 228.749 282.113 227.818C281.573 226.887 280.798 226.114 279.865 225.576L159.182 155.957C156.942 154.665 154.4 153.99 151.814 154C149.228 154.01 146.691 154.706 144.462 156.015L73.4899 197.839C72.6154 198.355 71.8913 199.09 71.3897 199.972C70.888 200.854 70.6262 201.851 70.6304 202.866C70.6346 203.88 70.9047 204.875 71.4137 205.753C71.9227 206.631 72.6529 207.36 73.5316 207.868Z",
    fill: "url(#paint1_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5316 203.762L195.883 274.353C197.771 275.442 199.915 276.012 202.096 276.003C204.276 275.994 206.415 275.408 208.295 274.303L279.907 232.102C280.835 231.557 281.604 230.778 282.137 229.843C282.67 228.908 282.948 227.85 282.944 226.774C282.939 225.698 282.653 224.642 282.113 223.712C281.573 222.781 280.798 222.008 279.865 221.47L159.182 151.851C156.942 150.559 154.4 149.884 151.814 149.894C149.228 149.904 146.691 150.6 144.462 151.909L73.4899 193.733C72.6154 194.249 71.8913 194.984 71.3897 195.865C70.888 196.747 70.6262 197.745 70.6304 198.759C70.6346 199.774 70.9047 200.769 71.4137 201.647C71.9227 202.524 72.6529 203.253 73.5316 203.762Z",
    fill: "url(#paint2_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.423 226.309L259.228 229.589C259.447 229.716 259.696 229.783 259.949 229.783C260.203 229.783 260.451 229.716 260.67 229.589L265.921 226.503C266.394 226.226 266.509 224.549 266.033 224.275L260.305 222.099C260.046 221.947 259.751 221.868 259.45 221.868C259.149 221.868 258.854 221.947 258.595 222.099L253.24 224.214C252.796 224.479 252.975 226.043 253.423 226.309Z",
    fill: "url(#paint3_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.421 225.23L259.226 228.51C259.445 228.637 259.694 228.705 259.947 228.705C260.2 228.705 260.449 228.637 260.668 228.51L265.921 225.424C266.029 225.361 266.119 225.271 266.181 225.163C266.244 225.054 266.276 224.932 266.276 224.807C266.276 224.682 266.244 224.559 266.181 224.45C266.119 224.342 266.029 224.252 265.921 224.189L260.31 221.022C260.05 220.871 259.755 220.791 259.454 220.791C259.153 220.791 258.858 220.871 258.599 221.022L253.421 224.064C253.319 224.124 253.234 224.209 253.176 224.311C253.117 224.413 253.085 224.529 253.085 224.647C253.085 224.765 253.117 224.881 253.176 224.984C253.234 225.086 253.319 225.171 253.421 225.23Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.423 225.172L259.228 228.452C259.447 228.579 259.695 228.647 259.949 228.647C260.202 228.647 260.451 228.579 260.67 228.452L265.923 225.366C266.028 225.304 266.115 225.214 266.175 225.108C266.235 225.001 266.266 224.88 266.264 224.758C266.264 224.758 266.264 224.758 266.264 224.743C266.278 224.878 266.253 225.013 266.192 225.134C266.131 225.255 266.037 225.355 265.92 225.424L260.668 228.51C260.449 228.638 260.2 228.705 259.947 228.705C259.693 228.705 259.445 228.638 259.226 228.51L253.421 225.23C253.309 225.166 253.218 225.07 253.159 224.954C253.101 224.839 253.077 224.709 253.091 224.581V224.593C253.09 224.71 253.12 224.826 253.178 224.928C253.237 225.029 253.321 225.114 253.423 225.172Z",
    fill: "url(#paint4_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.601 220.033L248.406 223.313C248.625 223.44 248.874 223.507 249.127 223.507C249.381 223.507 249.63 223.44 249.849 223.313L255.101 220.227C255.574 219.948 255.687 218.273 255.212 217.998L249.486 215.822C249.226 215.671 248.931 215.591 248.63 215.591C248.33 215.591 248.035 215.671 247.775 215.822L242.42 217.938C241.974 218.205 242.164 219.775 242.601 220.033Z",
    fill: "url(#paint5_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.603 218.954L248.408 222.234C248.627 222.362 248.876 222.429 249.13 222.429C249.383 222.429 249.632 222.362 249.851 222.234L255.103 219.148C255.211 219.085 255.301 218.995 255.363 218.887C255.426 218.778 255.459 218.655 255.459 218.53C255.459 218.405 255.426 218.283 255.363 218.174C255.301 218.066 255.211 217.976 255.103 217.913L249.494 214.744C249.234 214.593 248.939 214.513 248.638 214.513C248.338 214.513 248.043 214.593 247.783 214.744L242.605 217.786C242.503 217.845 242.417 217.93 242.358 218.032C242.299 218.135 242.267 218.251 242.267 218.37C242.267 218.488 242.298 218.604 242.357 218.707C242.416 218.809 242.501 218.895 242.603 218.954Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.603 218.898L248.408 222.178C248.627 222.305 248.876 222.372 249.129 222.372C249.383 222.372 249.632 222.305 249.851 222.178L255.103 219.092C255.209 219.029 255.296 218.94 255.356 218.834C255.416 218.727 255.447 218.606 255.445 218.484C255.445 218.484 255.445 218.484 255.445 218.469C255.459 218.604 255.434 218.74 255.373 218.861C255.311 218.983 255.216 219.084 255.099 219.152L249.846 222.238C249.627 222.366 249.379 222.433 249.125 222.433C248.872 222.433 248.623 222.366 248.404 222.238L242.599 218.958C242.487 218.894 242.397 218.798 242.338 218.683C242.28 218.568 242.256 218.439 242.27 218.311C242.27 218.316 242.27 218.32 242.27 218.325C242.27 218.442 242.3 218.556 242.359 218.657C242.418 218.757 242.502 218.841 242.603 218.898Z",
    fill: "url(#paint6_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.781 213.759L237.586 217.039C237.805 217.166 238.054 217.233 238.308 217.233C238.561 217.233 238.81 217.166 239.029 217.039L244.281 213.952C244.755 213.675 244.867 211.999 244.392 211.724L238.666 209.548C238.407 209.397 238.111 209.318 237.811 209.318C237.51 209.318 237.215 209.397 236.955 209.548L231.6 211.664C231.154 211.928 231.333 213.499 231.781 213.759Z",
    fill: "url(#paint7_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.784 212.68L237.589 215.96C237.808 216.087 238.057 216.154 238.31 216.154C238.563 216.154 238.812 216.087 239.031 215.96L244.284 212.874C244.392 212.811 244.481 212.721 244.544 212.613C244.606 212.504 244.639 212.382 244.639 212.257C244.639 212.132 244.606 212.009 244.544 211.9C244.481 211.792 244.392 211.702 244.284 211.639L238.672 208.472C238.413 208.321 238.117 208.241 237.817 208.241C237.516 208.241 237.221 208.321 236.961 208.472L231.784 211.514C231.682 211.573 231.597 211.659 231.538 211.761C231.479 211.863 231.448 211.979 231.448 212.097C231.448 212.215 231.479 212.331 231.538 212.433C231.597 212.536 231.682 212.621 231.784 212.68Z",
    fill: "url(#paint8_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.781 212.616L237.586 215.895C237.805 216.023 238.054 216.09 238.307 216.09C238.561 216.09 238.81 216.023 239.029 215.895L244.281 212.809C244.387 212.747 244.474 212.659 244.534 212.552C244.594 212.446 244.624 212.326 244.623 212.203C244.623 212.203 244.623 212.193 244.623 212.189C244.637 212.323 244.612 212.459 244.55 212.58C244.489 212.701 244.394 212.801 244.277 212.87L239.024 215.956C238.806 216.083 238.557 216.151 238.303 216.151C238.05 216.151 237.801 216.083 237.582 215.956L231.777 212.676C231.666 212.611 231.575 212.516 231.517 212.401C231.458 212.286 231.434 212.157 231.448 212.029C231.448 212.029 231.448 212.029 231.448 212.041C231.447 212.158 231.478 212.273 231.537 212.374C231.595 212.475 231.68 212.558 231.781 212.616Z",
    fill: "url(#paint9_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.961 207.48L226.766 210.76C226.985 210.888 227.234 210.955 227.487 210.955C227.741 210.955 227.99 210.888 228.208 210.76L233.461 207.674C233.934 207.397 234.047 205.721 233.574 205.446L227.846 203.27C227.586 203.118 227.291 203.039 226.99 203.039C226.69 203.039 226.394 203.118 226.135 203.27L220.78 205.385C220.332 205.646 220.511 207.222 220.961 207.48Z",
    fill: "url(#paint10_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.959 206.406L226.764 209.685C226.983 209.813 227.232 209.88 227.486 209.88C227.739 209.88 227.988 209.813 228.207 209.685L233.457 206.6C233.566 206.537 233.656 206.447 233.719 206.338C233.781 206.229 233.814 206.106 233.814 205.981C233.814 205.856 233.781 205.733 233.719 205.624C233.656 205.515 233.566 205.425 233.457 205.363L227.846 202.195C227.586 202.044 227.291 201.964 226.991 201.964C226.69 201.964 226.395 202.044 226.135 202.195L220.957 205.238C220.855 205.297 220.77 205.382 220.711 205.485C220.652 205.588 220.621 205.704 220.621 205.822C220.621 205.941 220.653 206.057 220.712 206.159C220.772 206.262 220.857 206.347 220.959 206.406Z",
    fill: "url(#paint11_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.961 206.346L226.766 209.625C226.985 209.753 227.234 209.82 227.487 209.82C227.741 209.82 227.989 209.753 228.208 209.625L233.461 206.539C233.566 206.477 233.654 206.388 233.714 206.281C233.774 206.174 233.805 206.054 233.803 205.931C233.803 205.931 233.803 205.931 233.803 205.916C233.817 206.051 233.792 206.187 233.731 206.307C233.67 206.428 233.576 206.529 233.459 206.597L228.206 209.684C227.987 209.811 227.739 209.878 227.485 209.878C227.232 209.878 226.983 209.811 226.764 209.684L220.959 206.404C220.848 206.339 220.757 206.244 220.698 206.129C220.64 206.014 220.616 205.884 220.63 205.756C220.63 205.756 220.63 205.756 220.63 205.771C220.629 205.887 220.659 206.002 220.718 206.103C220.776 206.204 220.86 206.288 220.961 206.346Z",
    fill: "url(#paint12_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.137 201.206L215.942 204.486C216.161 204.613 216.41 204.68 216.664 204.68C216.917 204.68 217.166 204.613 217.385 204.486L222.637 201.4C223.111 201.121 223.223 199.447 222.748 199.172L217.022 196.996C216.762 196.845 216.467 196.765 216.166 196.765C215.866 196.765 215.571 196.845 215.311 196.996L209.956 199.112C209.508 199.376 209.689 200.946 210.137 201.206Z",
    fill: "url(#paint13_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.138 200.13L215.943 203.41C216.162 203.537 216.41 203.604 216.664 203.604C216.917 203.604 217.166 203.537 217.385 203.41L222.638 200.323C222.746 200.261 222.835 200.171 222.898 200.062C222.96 199.954 222.993 199.831 222.993 199.706C222.993 199.581 222.96 199.458 222.898 199.35C222.835 199.242 222.746 199.151 222.638 199.089L217.026 195.921C216.767 195.77 216.471 195.69 216.171 195.69C215.87 195.69 215.575 195.77 215.315 195.921L210.138 198.964C210.036 199.023 209.951 199.108 209.892 199.211C209.833 199.313 209.802 199.429 209.802 199.547C209.802 199.665 209.833 199.781 209.892 199.883C209.951 199.985 210.036 200.07 210.138 200.13Z",
    fill: "url(#paint14_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.138 200.069L215.943 203.349C216.162 203.477 216.41 203.544 216.664 203.544C216.917 203.544 217.166 203.477 217.385 203.349L222.637 200.263C222.743 200.201 222.83 200.112 222.89 200.005C222.95 199.898 222.981 199.778 222.979 199.655C222.979 199.655 222.979 199.655 222.979 199.64C222.993 199.775 222.968 199.912 222.907 200.033C222.846 200.154 222.751 200.255 222.633 200.323L217.381 203.41C217.162 203.537 216.913 203.604 216.66 203.604C216.406 203.604 216.157 203.537 215.938 203.41L210.133 200.13C210.022 200.065 209.931 199.97 209.873 199.855C209.814 199.74 209.79 199.611 209.804 199.482C209.804 199.482 209.804 199.482 209.804 199.495C209.804 199.611 209.834 199.726 209.893 199.827C209.951 199.928 210.036 200.012 210.138 200.069Z",
    fill: "url(#paint15_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.318 194.93L205.123 198.21C205.341 198.338 205.59 198.405 205.844 198.405C206.097 198.405 206.346 198.338 206.565 198.21L211.818 195.124C212.291 194.847 212.403 193.171 211.93 192.896L206.202 190.72C205.943 190.569 205.647 190.489 205.347 190.489C205.046 190.489 204.751 190.569 204.491 190.72L199.136 192.835C198.69 193.102 198.869 194.672 199.318 194.93Z",
    fill: "url(#paint16_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.318 193.852L205.123 197.131C205.342 197.259 205.591 197.326 205.844 197.326C206.097 197.326 206.346 197.259 206.565 197.131L211.818 194.045C211.926 193.982 212.015 193.892 212.078 193.783C212.14 193.675 212.173 193.552 212.173 193.427C212.173 193.302 212.14 193.179 212.078 193.07C212.015 192.962 211.926 192.871 211.818 192.808L206.206 189.641C205.947 189.49 205.651 189.41 205.351 189.41C205.05 189.41 204.755 189.49 204.495 189.641L199.318 192.684C199.215 192.743 199.13 192.828 199.071 192.93C199.012 193.033 198.98 193.149 198.98 193.268C198.98 193.386 199.012 193.502 199.071 193.605C199.13 193.707 199.215 193.792 199.318 193.852Z",
    fill: "url(#paint17_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.318 193.793L205.123 197.073C205.342 197.201 205.59 197.268 205.844 197.268C206.097 197.268 206.346 197.201 206.565 197.073L211.818 193.987C211.923 193.925 212.01 193.836 212.07 193.729C212.13 193.622 212.161 193.501 212.159 193.379C212.159 193.379 212.159 193.379 212.159 193.364C212.173 193.499 212.148 193.635 212.087 193.756C212.025 193.876 211.93 193.977 211.813 194.045L206.561 197.131C206.342 197.259 206.093 197.326 205.84 197.326C205.586 197.326 205.338 197.259 205.119 197.131L199.314 193.852C199.202 193.787 199.111 193.692 199.053 193.577C198.994 193.462 198.97 193.332 198.984 193.204C198.984 193.208 198.984 193.212 198.984 193.217C198.983 193.334 199.014 193.449 199.072 193.55C199.131 193.652 199.216 193.736 199.318 193.793Z",
    fill: "url(#paint18_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.496 188.654L194.301 191.934C194.52 192.061 194.769 192.128 195.022 192.128C195.275 192.128 195.524 192.061 195.743 191.934L200.996 188.848C201.469 188.571 201.581 186.894 201.106 186.62L195.38 184.443C195.121 184.292 194.825 184.213 194.525 184.213C194.224 184.213 193.929 184.292 193.669 184.443L188.314 186.559C187.866 186.826 188.048 188.396 188.496 188.654Z",
    fill: "url(#paint19_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.496 187.575L194.3 190.855C194.519 190.983 194.768 191.05 195.022 191.05C195.275 191.05 195.524 190.983 195.743 190.855L200.995 187.769C201.104 187.706 201.193 187.616 201.256 187.508C201.318 187.399 201.351 187.277 201.351 187.152C201.351 187.027 201.318 186.904 201.256 186.795C201.193 186.687 201.104 186.597 200.995 186.534L195.384 183.367C195.125 183.216 194.829 183.136 194.529 183.136C194.228 183.136 193.933 183.216 193.673 183.367L188.496 186.409C188.394 186.469 188.309 186.554 188.25 186.656C188.191 186.758 188.16 186.874 188.16 186.992C188.16 187.11 188.191 187.226 188.25 187.329C188.309 187.431 188.394 187.516 188.496 187.575Z",
    fill: "url(#paint20_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.496 187.517L194.301 190.797C194.52 190.924 194.769 190.991 195.022 190.991C195.275 190.991 195.524 190.924 195.743 190.797L200.994 187.711C201.099 187.648 201.186 187.559 201.246 187.453C201.306 187.346 201.337 187.225 201.335 187.103C201.335 187.098 201.335 187.093 201.335 187.088C201.35 187.223 201.325 187.359 201.263 187.481C201.202 187.602 201.107 187.703 200.989 187.771L195.739 190.857C195.52 190.984 195.271 191.051 195.018 191.051C194.764 191.051 194.516 190.984 194.297 190.857L188.492 187.577C188.38 187.513 188.289 187.417 188.231 187.302C188.172 187.187 188.149 187.058 188.162 186.93C188.162 186.93 188.162 186.93 188.162 186.942C188.162 187.059 188.192 187.174 188.251 187.275C188.31 187.376 188.394 187.46 188.496 187.517Z",
    fill: "url(#paint21_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.674 182.378L183.479 185.657C183.698 185.785 183.947 185.852 184.2 185.852C184.454 185.852 184.702 185.785 184.921 185.657L190.174 182.572C190.647 182.295 190.759 180.618 190.284 180.343L184.559 178.167C184.299 178.016 184.004 177.936 183.703 177.936C183.402 177.936 183.107 178.016 182.847 178.167L177.493 180.283C177.045 180.548 177.218 182.12 177.674 182.378Z",
    fill: "url(#paint22_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.676 181.301L183.481 184.581C183.7 184.708 183.949 184.776 184.202 184.776C184.455 184.776 184.704 184.708 184.923 184.581L190.174 181.495C190.282 181.432 190.372 181.342 190.434 181.234C190.496 181.125 190.529 181.003 190.529 180.878C190.529 180.753 190.496 180.63 190.434 180.521C190.372 180.413 190.282 180.323 190.174 180.26L184.565 177.093C184.305 176.941 184.01 176.862 183.709 176.862C183.408 176.862 183.113 176.941 182.853 177.093L177.676 180.135C177.574 180.194 177.489 180.28 177.43 180.382C177.372 180.484 177.34 180.6 177.34 180.718C177.34 180.836 177.372 180.952 177.43 181.054C177.489 181.157 177.574 181.242 177.676 181.301Z",
    fill: "url(#paint23_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.674 181.241L183.479 184.521C183.698 184.648 183.947 184.716 184.2 184.716C184.454 184.716 184.702 184.648 184.921 184.521L190.174 181.435C190.279 181.372 190.367 181.283 190.427 181.176C190.487 181.07 190.517 180.949 190.516 180.827C190.516 180.827 190.516 180.826 190.516 180.812C190.53 180.946 190.505 181.082 190.444 181.203C190.383 181.324 190.288 181.424 190.172 181.493L184.919 184.579C184.7 184.706 184.452 184.773 184.198 184.773C183.945 184.773 183.696 184.706 183.477 184.579L177.672 181.299C177.56 181.235 177.47 181.139 177.411 181.024C177.353 180.909 177.329 180.78 177.343 180.651C177.343 180.651 177.343 180.652 177.343 180.664C177.341 180.781 177.372 180.896 177.43 180.997C177.488 181.099 177.572 181.183 177.674 181.241Z",
    fill: "url(#paint24_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.854 176.102L172.659 179.381C172.878 179.509 173.127 179.576 173.38 179.576C173.634 179.576 173.883 179.509 174.102 179.381L179.352 176.295C179.825 176.018 179.94 174.342 179.465 174.067L173.737 171.891C173.477 171.74 173.182 171.66 172.881 171.66C172.58 171.66 172.285 171.74 172.025 171.891L166.671 174.007C166.227 174.271 166.406 175.843 166.854 176.102Z",
    fill: "url(#paint25_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.854 175.023L172.659 178.303C172.878 178.43 173.127 178.497 173.381 178.497C173.634 178.497 173.883 178.43 174.102 178.303L179.354 175.217C179.463 175.154 179.553 175.064 179.616 174.955C179.679 174.847 179.712 174.724 179.712 174.598C179.712 174.473 179.679 174.35 179.616 174.241C179.553 174.132 179.463 174.042 179.354 173.98L173.743 170.812C173.484 170.661 173.188 170.581 172.888 170.581C172.587 170.581 172.292 170.661 172.032 170.812L166.854 173.855C166.752 173.914 166.667 173.999 166.608 174.102C166.548 174.204 166.517 174.32 166.517 174.439C166.517 174.557 166.548 174.674 166.608 174.776C166.667 174.879 166.752 174.964 166.854 175.023Z",
    fill: "url(#paint26_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.854 174.965L172.659 178.244C172.878 178.372 173.127 178.439 173.38 178.439C173.634 178.439 173.883 178.372 174.101 178.244L179.354 175.158C179.46 175.096 179.547 175.007 179.607 174.9C179.667 174.793 179.697 174.673 179.696 174.55C179.696 174.55 179.696 174.55 179.696 174.536C179.71 174.67 179.685 174.806 179.624 174.926C179.563 175.047 179.468 175.148 179.352 175.216L174.099 178.303C173.881 178.43 173.632 178.498 173.378 178.498C173.125 178.498 172.876 178.43 172.657 178.303L166.852 175.023C166.74 174.958 166.65 174.863 166.591 174.748C166.533 174.633 166.509 174.504 166.523 174.375C166.523 174.375 166.523 174.375 166.523 174.388C166.522 174.505 166.552 174.62 166.61 174.721C166.668 174.823 166.752 174.907 166.854 174.965Z",
    fill: "url(#paint27_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.032 169.825L161.837 173.105C162.056 173.233 162.305 173.3 162.558 173.3C162.812 173.3 163.06 173.233 163.279 173.105L168.532 170.019C169.005 169.742 169.117 168.066 168.644 167.791L162.917 165.615C162.657 165.464 162.362 165.384 162.061 165.384C161.76 165.384 161.465 165.464 161.205 165.615L155.851 167.731C155.403 167.995 155.584 169.567 156.032 169.825Z",
    fill: "url(#paint28_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.034 168.749L161.839 172.029C162.058 172.156 162.307 172.223 162.56 172.223C162.814 172.223 163.062 172.156 163.281 172.029L168.534 168.942C168.643 168.88 168.733 168.79 168.795 168.681C168.858 168.573 168.891 168.449 168.891 168.324C168.891 168.199 168.858 168.076 168.795 167.967C168.733 167.859 168.643 167.768 168.534 167.706L162.923 164.538C162.663 164.387 162.368 164.307 162.067 164.307C161.766 164.307 161.471 164.387 161.212 164.538L156.034 167.581C155.932 167.64 155.846 167.725 155.787 167.828C155.728 167.93 155.697 168.046 155.697 168.165C155.697 168.283 155.728 168.399 155.787 168.502C155.846 168.604 155.932 168.69 156.034 168.749Z",
    fill: "url(#paint29_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.032 168.688L161.837 171.968C162.056 172.096 162.305 172.163 162.558 172.163C162.812 172.163 163.06 172.096 163.279 171.968L168.532 168.882C168.637 168.82 168.724 168.731 168.784 168.624C168.844 168.517 168.875 168.397 168.874 168.274C168.874 168.274 168.874 168.274 168.874 168.26C168.887 168.394 168.862 168.53 168.802 168.65C168.741 168.771 168.646 168.872 168.53 168.941L163.277 172.027C163.058 172.154 162.809 172.221 162.556 172.221C162.302 172.221 162.054 172.154 161.835 172.027L156.03 168.747C155.918 168.682 155.827 168.587 155.769 168.472C155.711 168.357 155.687 168.227 155.701 168.099C155.7 168.103 155.7 168.108 155.701 168.112C155.699 168.229 155.729 168.344 155.788 168.445C155.846 168.547 155.93 168.631 156.032 168.688Z",
    fill: "url(#paint30_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.21 163.551L151.015 166.831C151.234 166.959 151.483 167.026 151.736 167.026C151.99 167.026 152.238 166.959 152.457 166.831L157.708 163.745C158.181 163.468 158.294 161.792 157.818 161.517L152.093 159.341C151.833 159.189 151.538 159.11 151.237 159.11C150.936 159.11 150.641 159.189 150.381 159.341L145.027 161.457C144.583 161.721 144.762 163.293 145.21 163.551Z",
    fill: "url(#paint31_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.21 162.475L151.015 165.755C151.234 165.882 151.483 165.949 151.736 165.949C151.989 165.949 152.238 165.882 152.457 165.755L157.71 162.669C157.818 162.606 157.908 162.515 157.97 162.407C158.032 162.298 158.065 162.175 158.065 162.05C158.065 161.925 158.032 161.802 157.97 161.694C157.908 161.585 157.818 161.495 157.71 161.432L152.099 158.265C151.839 158.113 151.544 158.033 151.243 158.033C150.943 158.033 150.647 158.113 150.387 158.265L145.21 161.307C145.107 161.366 145.022 161.451 144.963 161.554C144.904 161.656 144.873 161.772 144.873 161.891C144.873 162.009 144.904 162.125 144.963 162.228C145.022 162.33 145.107 162.416 145.21 162.475Z",
    fill: "url(#paint32_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.21 162.415L151.015 165.694C151.234 165.822 151.483 165.889 151.736 165.889C151.99 165.889 152.238 165.822 152.457 165.694L157.71 162.608C157.815 162.546 157.903 162.457 157.963 162.35C158.023 162.244 158.053 162.123 158.052 162C158.052 162 158.052 162 158.052 161.986C158.065 162.12 158.04 162.256 157.979 162.377C157.917 162.497 157.823 162.598 157.706 162.667L152.453 165.752C152.234 165.88 151.985 165.947 151.732 165.947C151.478 165.947 151.23 165.88 151.011 165.752L145.206 162.473C145.094 162.408 145.003 162.312 144.944 162.197C144.886 162.082 144.862 161.952 144.877 161.823C144.877 161.823 144.877 161.823 144.877 161.836C144.875 161.953 144.906 162.069 144.964 162.171C145.023 162.272 145.108 162.357 145.21 162.415Z",
    fill: "url(#paint33_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.134 231.7L249.938 234.98C250.157 235.108 250.406 235.175 250.66 235.175C250.913 235.175 251.162 235.108 251.381 234.98L256.633 231.894C257.106 231.617 257.219 229.941 256.744 229.666L251.016 227.49C250.756 227.338 250.461 227.259 250.16 227.259C249.86 227.259 249.564 227.338 249.305 227.49L243.95 229.605C243.504 229.87 243.685 231.442 244.134 231.7Z",
    fill: "url(#paint34_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.135 230.63L249.94 233.909C250.159 234.037 250.408 234.104 250.661 234.104C250.915 234.104 251.164 234.037 251.383 233.909L256.635 230.824C256.743 230.761 256.833 230.671 256.895 230.562C256.958 230.454 256.991 230.331 256.991 230.206C256.991 230.081 256.958 229.958 256.895 229.85C256.833 229.742 256.743 229.652 256.635 229.589L251.024 226.421C250.765 226.27 250.469 226.19 250.169 226.19C249.868 226.19 249.573 226.27 249.313 226.421L244.135 229.464C244.033 229.523 243.948 229.608 243.89 229.71C243.831 229.813 243.8 229.929 243.8 230.047C243.8 230.165 243.831 230.281 243.89 230.383C243.948 230.485 244.033 230.571 244.135 230.63Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.133 230.565L249.938 233.845C250.157 233.973 250.406 234.04 250.659 234.04C250.913 234.04 251.161 233.973 251.38 233.845L256.631 230.759C256.736 230.697 256.823 230.608 256.883 230.502C256.943 230.395 256.974 230.275 256.973 230.153C256.973 230.153 256.973 230.153 256.973 230.138C256.987 230.273 256.962 230.41 256.9 230.531C256.839 230.652 256.744 230.753 256.627 230.821L251.376 233.908C251.157 234.035 250.908 234.102 250.655 234.102C250.402 234.102 250.153 234.035 249.934 233.908L244.129 230.628C244.017 230.563 243.927 230.468 243.868 230.353C243.81 230.238 243.786 230.108 243.8 229.98C243.8 229.98 243.8 229.98 243.8 229.993C243.799 230.109 243.83 230.224 243.889 230.324C243.947 230.425 244.032 230.508 244.133 230.565Z",
    fill: "url(#paint35_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.313 225.426L239.118 228.706C239.337 228.833 239.586 228.9 239.839 228.9C240.093 228.9 240.341 228.833 240.56 228.706L245.813 225.62C246.286 225.343 246.399 223.667 245.926 223.392L240.198 221.216C239.938 221.064 239.643 220.985 239.342 220.985C239.042 220.985 238.746 221.064 238.487 221.216L233.132 223.331C232.686 223.598 232.865 225.168 233.313 225.426Z",
    fill: "url(#paint36_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.315 224.348L239.12 227.627C239.339 227.755 239.588 227.822 239.841 227.822C240.095 227.822 240.344 227.755 240.563 227.627L245.815 224.541C245.924 224.478 246.014 224.388 246.077 224.28C246.139 224.171 246.172 224.048 246.172 223.922C246.172 223.797 246.139 223.674 246.077 223.566C246.014 223.457 245.924 223.367 245.815 223.304L240.204 220.137C239.944 219.986 239.649 219.906 239.348 219.906C239.048 219.906 238.752 219.986 238.493 220.137L233.315 223.179C233.213 223.238 233.128 223.324 233.068 223.426C233.009 223.529 232.978 223.645 232.978 223.763C232.978 223.882 233.009 223.998 233.068 224.1C233.128 224.203 233.213 224.288 233.315 224.348Z",
    fill: "url(#paint37_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.313 224.287L239.118 227.567C239.337 227.694 239.586 227.761 239.84 227.761C240.093 227.761 240.342 227.694 240.561 227.567L245.811 224.481C245.917 224.418 246.004 224.329 246.064 224.222C246.124 224.116 246.155 223.995 246.153 223.873C246.153 223.868 246.153 223.863 246.153 223.858C246.167 223.993 246.142 224.129 246.081 224.251C246.019 224.372 245.924 224.472 245.807 224.541L240.557 227.627C240.338 227.754 240.089 227.821 239.835 227.821C239.582 227.821 239.333 227.754 239.114 227.627L233.309 224.347C233.198 224.282 233.107 224.187 233.048 224.071C232.99 223.956 232.966 223.826 232.98 223.698C232.98 223.698 232.98 223.698 232.98 223.712C232.979 223.829 233.01 223.944 233.068 224.045C233.127 224.146 233.212 224.23 233.313 224.287Z",
    fill: "url(#paint38_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.492 219.148L228.297 222.428C228.516 222.555 228.764 222.622 229.018 222.622C229.271 222.622 229.52 222.555 229.739 222.428L234.989 219.342C235.462 219.065 235.575 217.388 235.102 217.113L229.376 214.937C229.116 214.786 228.821 214.707 228.52 214.707C228.22 214.707 227.925 214.786 227.665 214.937L222.31 217.053C221.864 217.32 222.043 218.89 222.492 219.148Z",
    fill: "url(#paint39_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.494 218.071L228.298 221.351C228.517 221.478 228.766 221.546 229.02 221.546C229.273 221.546 229.522 221.478 229.741 221.351L234.993 218.265C235.102 218.202 235.191 218.112 235.254 218.004C235.316 217.895 235.349 217.773 235.349 217.648C235.349 217.523 235.316 217.4 235.254 217.291C235.191 217.183 235.102 217.093 234.993 217.03L229.384 213.863C229.125 213.712 228.829 213.632 228.529 213.632C228.228 213.632 227.933 213.712 227.673 213.863L222.496 216.905C222.394 216.964 222.309 217.049 222.25 217.152C222.19 217.254 222.159 217.37 222.159 217.488C222.159 217.606 222.19 217.722 222.248 217.824C222.307 217.926 222.392 218.012 222.494 218.071Z",
    fill: "url(#paint40_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.5 218.011L228.305 221.291C228.524 221.418 228.772 221.485 229.026 221.485C229.279 221.485 229.528 221.418 229.747 221.291L234.998 218.205C235.103 218.143 235.191 218.054 235.251 217.948C235.311 217.841 235.343 217.721 235.342 217.599C235.342 217.594 235.342 217.589 235.342 217.584C235.356 217.719 235.331 217.855 235.269 217.976C235.208 218.098 235.113 218.198 234.995 218.267L229.745 221.353C229.526 221.481 229.277 221.548 229.024 221.548C228.77 221.548 228.521 221.481 228.303 221.353L222.498 218.073C222.386 218.009 222.295 217.913 222.237 217.798C222.179 217.683 222.155 217.554 222.168 217.426C222.168 217.426 222.168 217.426 222.168 217.438C222.168 217.554 222.198 217.669 222.257 217.769C222.315 217.87 222.399 217.953 222.5 218.011Z",
    fill: "url(#paint41_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.67 212.874L217.475 216.153C217.694 216.281 217.943 216.348 218.196 216.348C218.449 216.348 218.698 216.281 218.917 216.153L224.17 213.068C224.643 212.791 224.755 211.114 224.28 210.839L218.552 208.663C218.293 208.512 217.997 208.432 217.697 208.432C217.396 208.432 217.101 208.512 216.841 208.663L211.486 210.779C211.042 211.044 211.222 212.616 211.67 212.874Z",
    fill: "url(#paint42_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.672 211.797L217.477 215.077C217.696 215.204 217.945 215.271 218.198 215.271C218.451 215.271 218.7 215.204 218.919 215.077L224.172 211.991C224.28 211.928 224.37 211.838 224.432 211.73C224.494 211.621 224.527 211.498 224.527 211.373C224.527 211.248 224.494 211.126 224.432 211.017C224.37 210.909 224.28 210.819 224.172 210.756L218.561 207.589C218.301 207.437 218.006 207.357 217.705 207.357C217.404 207.357 217.109 207.437 216.85 207.589L211.672 210.631C211.57 210.691 211.485 210.776 211.426 210.878C211.367 210.98 211.336 211.096 211.336 211.214C211.336 211.332 211.367 211.448 211.426 211.551C211.485 211.653 211.57 211.738 211.672 211.797Z",
    fill: "url(#paint43_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.67 211.737L217.475 215.017C217.694 215.144 217.943 215.211 218.196 215.211C218.449 215.211 218.698 215.144 218.917 215.017L224.17 211.931C224.275 211.868 224.362 211.779 224.422 211.672C224.482 211.566 224.513 211.445 224.511 211.323C224.511 211.323 224.511 211.323 224.511 211.308C224.525 211.443 224.5 211.578 224.439 211.699C224.378 211.819 224.284 211.92 224.168 211.989L218.915 215.075C218.696 215.203 218.447 215.27 218.194 215.27C217.94 215.27 217.692 215.203 217.473 215.075L211.668 211.795C211.556 211.73 211.465 211.635 211.406 211.519C211.348 211.404 211.324 211.274 211.338 211.146C211.338 211.146 211.338 211.146 211.338 211.158C211.337 211.275 211.367 211.391 211.425 211.493C211.483 211.594 211.568 211.679 211.67 211.737Z",
    fill: "url(#paint44_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.856 206.598L206.661 209.877C206.88 210.005 207.129 210.072 207.382 210.072C207.636 210.072 207.885 210.005 208.104 209.877L213.356 206.791C213.829 206.514 213.944 204.838 213.469 204.563L207.743 202.387C207.483 202.236 207.188 202.156 206.887 202.156C206.587 202.156 206.291 202.236 206.032 202.387L200.677 204.503C200.231 204.767 200.402 206.339 200.856 206.598Z",
    fill: "url(#paint45_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.846 205.517L206.651 208.797C206.87 208.924 207.119 208.991 207.372 208.991C207.626 208.991 207.874 208.924 208.093 208.797L213.346 205.711C213.454 205.648 213.544 205.557 213.606 205.449C213.668 205.34 213.701 205.217 213.701 205.092C213.701 204.967 213.668 204.844 213.606 204.736C213.544 204.627 213.454 204.537 213.346 204.474L207.735 201.307C207.475 201.155 207.18 201.075 206.879 201.075C206.578 201.075 206.283 201.155 206.023 201.307L200.846 204.349C200.743 204.408 200.658 204.493 200.599 204.596C200.54 204.698 200.509 204.814 200.509 204.933C200.509 205.051 200.54 205.168 200.599 205.27C200.658 205.373 200.743 205.458 200.846 205.517Z",
    fill: "url(#paint46_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.85 205.461L206.655 208.74C206.874 208.868 207.123 208.935 207.376 208.935C207.629 208.935 207.878 208.868 208.097 208.74L213.35 205.654C213.455 205.592 213.542 205.503 213.602 205.396C213.662 205.289 213.693 205.169 213.691 205.046C213.691 205.046 213.691 205.046 213.691 205.032C213.705 205.166 213.68 205.302 213.619 205.423C213.557 205.544 213.463 205.644 213.346 205.713L208.093 208.799C207.874 208.926 207.625 208.993 207.372 208.993C207.118 208.993 206.87 208.926 206.651 208.799L200.846 205.519C200.734 205.454 200.643 205.359 200.585 205.244C200.526 205.129 200.503 205 200.516 204.871C200.516 204.871 200.516 204.871 200.516 204.884C200.515 205.001 200.546 205.116 200.605 205.218C200.663 205.319 200.748 205.403 200.85 205.461Z",
    fill: "url(#paint47_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.028 200.321L195.833 203.601C196.052 203.729 196.301 203.795 196.554 203.795C196.807 203.795 197.056 203.729 197.275 203.601L202.528 200.515C203.001 200.238 203.113 198.562 202.638 198.287L196.913 196.111C196.653 195.96 196.358 195.88 196.057 195.88C195.756 195.88 195.461 195.96 195.201 196.111L189.847 198.227C189.401 198.491 189.582 200.061 190.028 200.321Z",
    fill: "url(#paint48_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.028 199.243L195.833 202.523C196.052 202.65 196.301 202.717 196.554 202.717C196.807 202.717 197.056 202.65 197.275 202.523L202.528 199.437C202.636 199.374 202.726 199.284 202.788 199.175C202.851 199.067 202.883 198.944 202.883 198.819C202.883 198.694 202.851 198.571 202.788 198.463C202.726 198.355 202.636 198.265 202.528 198.202L196.917 195.035C196.657 194.883 196.362 194.803 196.061 194.803C195.761 194.803 195.465 194.883 195.206 195.035L190.028 198.077C189.926 198.136 189.841 198.221 189.782 198.324C189.724 198.426 189.692 198.542 189.692 198.66C189.692 198.778 189.724 198.894 189.782 198.996C189.841 199.098 189.926 199.184 190.028 199.243Z",
    fill: "url(#paint49_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.028 199.185L195.833 202.464C196.052 202.592 196.301 202.659 196.554 202.659C196.808 202.659 197.056 202.592 197.275 202.464L202.528 199.378C202.633 199.316 202.72 199.227 202.78 199.121C202.84 199.015 202.871 198.894 202.87 198.772C202.87 198.772 202.87 198.772 202.87 198.758C202.884 198.892 202.859 199.028 202.798 199.149C202.737 199.27 202.643 199.37 202.526 199.439L197.273 202.525C197.054 202.652 196.806 202.719 196.552 202.719C196.299 202.719 196.05 202.652 195.831 202.525L190.026 199.245C189.914 199.18 189.824 199.085 189.765 198.97C189.707 198.855 189.683 198.726 189.697 198.597C189.697 198.597 189.697 198.597 189.697 198.612C189.696 198.728 189.727 198.842 189.785 198.943C189.843 199.044 189.927 199.127 190.028 199.185Z",
    fill: "url(#paint50_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.205 194.046L185.01 197.325C185.229 197.453 185.478 197.52 185.731 197.52C185.985 197.52 186.234 197.453 186.453 197.325L191.705 194.239C192.178 193.962 192.291 192.286 191.818 192.011L186.09 189.835C185.83 189.684 185.535 189.604 185.234 189.604C184.934 189.604 184.638 189.684 184.379 189.835L179.024 191.951C178.576 192.215 178.757 193.785 179.205 194.046Z",
    fill: "url(#paint51_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.205 192.967L185.01 196.246C185.229 196.374 185.478 196.441 185.732 196.441C185.985 196.441 186.234 196.374 186.453 196.246L191.705 193.161C191.813 193.097 191.903 193.007 191.965 192.899C192.028 192.79 192.06 192.667 192.06 192.542C192.06 192.417 192.028 192.294 191.965 192.185C191.903 192.077 191.813 191.987 191.705 191.924L186.094 188.756C185.834 188.605 185.539 188.526 185.238 188.526C184.938 188.526 184.643 188.605 184.383 188.756L179.205 191.799C179.103 191.858 179.018 191.943 178.958 192.046C178.899 192.148 178.868 192.264 178.868 192.383C178.868 192.501 178.899 192.618 178.958 192.72C179.018 192.823 179.103 192.908 179.205 192.967Z",
    fill: "url(#paint52_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.205 192.909L185.01 196.188C185.229 196.316 185.478 196.383 185.732 196.383C185.985 196.383 186.234 196.316 186.453 196.188L191.703 193.102C191.808 193.04 191.895 192.951 191.955 192.845C192.015 192.739 192.046 192.618 192.045 192.496C192.045 192.496 192.045 192.496 192.045 192.48C192.059 192.614 192.034 192.75 191.973 192.871C191.912 192.991 191.817 193.092 191.701 193.161L186.451 196.246C186.232 196.374 185.983 196.442 185.729 196.442C185.476 196.442 185.227 196.374 185.008 196.246L179.203 192.967C179.091 192.902 179.001 192.806 178.942 192.691C178.884 192.575 178.86 192.446 178.874 192.317C178.874 192.317 178.874 192.317 178.874 192.33C178.872 192.447 178.902 192.563 178.96 192.664C179.019 192.766 179.103 192.851 179.205 192.909Z",
    fill: "url(#paint53_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.382 187.769L174.187 191.049C174.406 191.176 174.655 191.243 174.908 191.243C175.161 191.243 175.41 191.176 175.629 191.049L180.882 187.963C181.355 187.686 181.468 186.009 180.992 185.735L175.267 183.559C175.007 183.407 174.712 183.328 174.411 183.328C174.111 183.328 173.815 183.407 173.556 183.559L168.201 185.674C167.757 185.941 167.938 187.511 168.382 187.769Z",
    fill: "url(#paint54_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.388 186.692L174.193 189.972C174.412 190.1 174.661 190.167 174.914 190.167C175.168 190.167 175.417 190.1 175.635 189.972L180.888 186.886C180.996 186.823 181.087 186.733 181.149 186.625C181.212 186.516 181.245 186.393 181.245 186.268C181.245 186.142 181.212 186.019 181.149 185.911C181.087 185.802 180.996 185.712 180.888 185.649L175.279 182.482C175.019 182.331 174.724 182.251 174.423 182.251C174.123 182.251 173.827 182.331 173.568 182.482L168.39 185.524C168.287 185.583 168.202 185.668 168.143 185.771C168.083 185.873 168.052 185.989 168.052 186.108C168.052 186.226 168.083 186.343 168.142 186.445C168.201 186.548 168.286 186.633 168.388 186.692Z",
    fill: "url(#paint55_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.386 186.634L174.191 189.914C174.41 190.041 174.659 190.108 174.912 190.108C175.165 190.108 175.414 190.041 175.633 189.914L180.884 186.828C180.989 186.766 181.077 186.676 181.137 186.57C181.197 186.463 181.227 186.342 181.226 186.22C181.226 186.22 181.226 186.22 181.226 186.205C181.24 186.34 181.215 186.476 181.153 186.597C181.092 186.717 180.997 186.818 180.88 186.886L175.629 189.972C175.41 190.099 175.161 190.166 174.908 190.166C174.655 190.166 174.406 190.099 174.187 189.972L168.382 186.692C168.27 186.628 168.179 186.533 168.121 186.418C168.062 186.303 168.039 186.173 168.053 186.045C168.053 186.045 168.053 186.045 168.053 186.057C168.052 186.175 168.082 186.29 168.141 186.391C168.199 186.493 168.284 186.577 168.386 186.634Z",
    fill: "url(#paint56_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.564 181.493L163.369 184.772C163.588 184.9 163.837 184.967 164.09 184.967C164.344 184.967 164.592 184.9 164.811 184.772L170.062 181.686C170.535 181.41 170.648 179.733 170.172 179.458L164.447 177.282C164.187 177.131 163.892 177.051 163.591 177.051C163.29 177.051 162.995 177.131 162.735 177.282L157.381 179.398C156.935 179.665 157.116 181.235 157.564 181.493Z",
    fill: "url(#paint57_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.564 180.416L163.369 183.696C163.588 183.823 163.837 183.89 164.09 183.89C164.344 183.89 164.593 183.823 164.811 183.696L170.064 180.61C170.172 180.547 170.262 180.457 170.324 180.349C170.386 180.24 170.42 180.117 170.42 179.992C170.42 179.867 170.386 179.745 170.324 179.636C170.262 179.528 170.172 179.438 170.064 179.375L164.453 176.208C164.193 176.056 163.898 175.977 163.597 175.977C163.297 175.977 163.001 176.056 162.742 176.208L157.564 179.25C157.462 179.31 157.377 179.395 157.318 179.497C157.259 179.599 157.229 179.715 157.229 179.833C157.229 179.951 157.259 180.067 157.318 180.169C157.377 180.272 157.462 180.357 157.564 180.416Z",
    fill: "url(#paint58_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.564 180.358L163.369 183.638C163.588 183.765 163.837 183.832 164.09 183.832C164.344 183.832 164.593 183.765 164.812 183.638L170.064 180.552C170.169 180.49 170.257 180.401 170.317 180.295C170.377 180.188 170.407 180.068 170.406 179.946C170.406 179.946 170.406 179.946 170.406 179.931C170.42 180.066 170.395 180.201 170.334 180.322C170.273 180.443 170.179 180.543 170.062 180.612L164.809 183.698C164.59 183.825 164.342 183.893 164.088 183.893C163.835 183.893 163.586 183.825 163.367 183.698L157.562 180.418C157.451 180.354 157.36 180.258 157.301 180.143C157.243 180.028 157.219 179.899 157.233 179.771C157.233 179.771 157.233 179.771 157.233 179.783C157.232 179.9 157.262 180.015 157.321 180.116C157.379 180.217 157.463 180.3 157.564 180.358Z",
    fill: "url(#paint59_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.742 175.219L152.547 178.499C152.766 178.626 153.015 178.693 153.268 178.693C153.522 178.693 153.771 178.626 153.99 178.499L159.24 175.412C159.713 175.135 159.828 173.459 159.353 173.184L153.625 171.008C153.365 170.857 153.07 170.777 152.769 170.777C152.469 170.777 152.173 170.857 151.914 171.008L146.559 173.124C146.113 173.388 146.294 174.958 146.742 175.219Z",
    fill: "url(#paint60_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.743 174.14L152.548 177.42C152.766 177.547 153.015 177.614 153.269 177.614C153.522 177.614 153.771 177.547 153.99 177.42L159.243 174.334C159.351 174.271 159.44 174.181 159.503 174.073C159.565 173.964 159.598 173.841 159.598 173.716C159.598 173.591 159.565 173.469 159.503 173.36C159.44 173.252 159.351 173.162 159.243 173.099L153.631 169.932C153.372 169.78 153.076 169.701 152.776 169.701C152.475 169.701 152.18 169.78 151.92 169.932L146.743 172.974C146.64 173.033 146.556 173.118 146.497 173.221C146.438 173.323 146.407 173.439 146.407 173.557C146.407 173.675 146.438 173.791 146.497 173.893C146.556 173.996 146.64 174.081 146.743 174.14Z",
    fill: "url(#paint61_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.742 174.082L152.547 177.362C152.766 177.489 153.015 177.556 153.268 177.556C153.522 177.556 153.771 177.489 153.99 177.362L159.242 174.275C159.347 174.213 159.434 174.125 159.494 174.018C159.554 173.912 159.585 173.791 159.584 173.669C159.584 173.665 159.584 173.66 159.584 173.655C159.598 173.789 159.573 173.925 159.512 174.046C159.451 174.167 159.357 174.267 159.24 174.336L153.988 177.422C153.769 177.549 153.52 177.616 153.266 177.616C153.013 177.616 152.764 177.549 152.545 177.422L146.74 174.142C146.629 174.078 146.538 173.982 146.479 173.867C146.421 173.752 146.397 173.623 146.411 173.495C146.411 173.495 146.411 173.494 146.411 173.507C146.41 173.624 146.44 173.738 146.499 173.839C146.557 173.94 146.641 174.024 146.742 174.082Z",
    fill: "url(#paint62_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.922 168.943L141.727 172.222C141.946 172.349 142.195 172.417 142.448 172.417C142.702 172.417 142.951 172.349 143.17 172.222L148.422 169.136C148.895 168.857 149.01 167.183 148.535 166.908L142.807 164.732C142.547 164.581 142.252 164.501 141.951 164.501C141.651 164.501 141.355 164.581 141.096 164.732L135.741 166.848C135.285 167.112 135.474 168.691 135.922 168.943Z",
    fill: "url(#paint63_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.925 167.864L141.729 171.144C141.948 171.271 142.197 171.338 142.451 171.338C142.704 171.338 142.953 171.271 143.172 171.144L148.422 168.058C148.53 167.995 148.62 167.905 148.682 167.796C148.745 167.688 148.778 167.565 148.778 167.44C148.778 167.315 148.745 167.192 148.682 167.084C148.62 166.976 148.53 166.886 148.422 166.823L142.811 163.655C142.551 163.504 142.256 163.424 141.955 163.424C141.655 163.424 141.359 163.504 141.1 163.655L135.922 166.698C135.82 166.757 135.736 166.843 135.677 166.945C135.619 167.047 135.588 167.164 135.588 167.282C135.588 167.4 135.619 167.515 135.678 167.618C135.737 167.72 135.822 167.805 135.925 167.864Z",
    fill: "url(#paint64_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.923 167.806L141.728 171.085C141.946 171.213 142.195 171.28 142.449 171.28C142.702 171.28 142.951 171.213 143.17 171.085L148.423 167.999C148.528 167.937 148.615 167.848 148.675 167.741C148.735 167.634 148.766 167.514 148.764 167.391C148.764 167.391 148.764 167.391 148.764 167.377C148.778 167.511 148.753 167.647 148.692 167.768C148.631 167.888 148.537 167.989 148.421 168.058L143.168 171.143C142.949 171.271 142.7 171.338 142.447 171.338C142.193 171.338 141.945 171.271 141.726 171.143L135.921 167.864C135.809 167.8 135.718 167.704 135.659 167.589C135.601 167.474 135.577 167.344 135.591 167.216C135.591 167.22 135.591 167.224 135.591 167.229C135.59 167.346 135.62 167.461 135.679 167.562C135.737 167.664 135.821 167.748 135.923 167.806Z",
    fill: "url(#paint65_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.845 237.092L240.65 240.371C240.869 240.499 241.118 240.566 241.371 240.566C241.625 240.566 241.874 240.499 242.093 240.371L247.345 237.285C247.818 237.008 247.931 235.332 247.456 235.057L241.73 232.881C241.47 232.73 241.175 232.65 240.874 232.65C240.574 232.65 240.279 232.73 240.019 232.881L234.664 234.996C234.216 235.263 234.397 236.833 234.845 237.092Z",
    fill: "url(#paint66_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.843 236.015L240.648 239.294C240.867 239.422 241.116 239.489 241.369 239.489C241.623 239.489 241.871 239.422 242.09 239.294L247.341 236.209C247.45 236.146 247.54 236.056 247.603 235.947C247.665 235.838 247.698 235.715 247.698 235.59C247.698 235.465 247.665 235.342 247.603 235.233C247.54 235.124 247.45 235.034 247.341 234.972L241.73 231.804C241.47 231.653 241.175 231.573 240.874 231.573C240.574 231.573 240.278 231.653 240.019 231.804L234.841 234.847C234.739 234.906 234.653 234.991 234.594 235.094C234.535 235.197 234.505 235.313 234.505 235.431C234.505 235.55 234.536 235.666 234.596 235.768C234.655 235.871 234.74 235.956 234.843 236.015Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.845 235.957L240.65 239.236C240.869 239.364 241.118 239.431 241.372 239.431C241.625 239.431 241.874 239.364 242.093 239.236L247.345 236.15C247.451 236.088 247.538 235.999 247.598 235.892C247.658 235.785 247.689 235.665 247.687 235.542C247.687 235.542 247.687 235.542 247.687 235.527C247.701 235.662 247.676 235.799 247.615 235.92C247.553 236.041 247.458 236.142 247.341 236.211L242.089 239.297C241.87 239.424 241.621 239.491 241.367 239.491C241.114 239.491 240.865 239.424 240.646 239.297L234.841 236.017C234.73 235.952 234.639 235.857 234.581 235.742C234.522 235.627 234.498 235.498 234.512 235.369C234.512 235.369 234.512 235.369 234.512 235.382C234.512 235.499 234.542 235.613 234.601 235.714C234.659 235.815 234.744 235.899 234.845 235.957Z",
    fill: "url(#paint67_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.024 230.817L229.828 234.097C230.047 234.224 230.296 234.292 230.55 234.292C230.803 234.292 231.052 234.224 231.271 234.097L236.523 231.011C236.997 230.732 237.109 229.058 236.636 228.783L230.908 226.607C230.649 226.455 230.353 226.376 230.053 226.376C229.752 226.376 229.457 226.455 229.197 226.607L223.842 228.723C223.394 228.987 223.576 230.557 224.024 230.817Z",
    fill: "url(#paint68_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.023 229.739L229.828 233.018C230.047 233.146 230.296 233.213 230.549 233.213C230.803 233.213 231.052 233.146 231.271 233.018L236.523 229.932C236.631 229.869 236.721 229.779 236.783 229.67C236.846 229.562 236.879 229.439 236.879 229.314C236.879 229.189 236.846 229.066 236.783 228.957C236.721 228.849 236.631 228.759 236.523 228.696L230.912 225.528C230.653 225.377 230.357 225.297 230.057 225.297C229.756 225.297 229.461 225.377 229.201 225.528L224.023 228.57C223.921 228.63 223.836 228.715 223.776 228.818C223.717 228.92 223.686 229.036 223.686 229.155C223.686 229.273 223.717 229.389 223.776 229.492C223.836 229.594 223.921 229.68 224.023 229.739Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.024 229.68L229.829 232.96C230.048 233.087 230.297 233.155 230.55 233.155C230.803 233.155 231.052 233.087 231.271 232.96L236.524 229.874C236.629 229.812 236.716 229.723 236.776 229.616C236.836 229.509 236.867 229.389 236.866 229.266V229.251C236.879 229.386 236.854 229.522 236.793 229.643C236.731 229.763 236.636 229.864 236.52 229.932L231.267 233.018C231.048 233.146 230.799 233.213 230.546 233.213C230.292 233.213 230.043 233.146 229.825 233.018L224.02 229.739C223.908 229.674 223.817 229.579 223.759 229.464C223.7 229.349 223.677 229.219 223.69 229.091C223.69 229.095 223.69 229.099 223.69 229.104C223.689 229.221 223.72 229.336 223.778 229.437C223.837 229.539 223.922 229.623 224.024 229.68Z",
    fill: "url(#paint69_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.202 224.543L219.007 227.823C219.225 227.95 219.474 228.017 219.728 228.017C219.981 228.017 220.23 227.95 220.449 227.823L225.701 224.737C226.174 224.46 226.287 222.784 225.812 222.509L220.086 220.333C219.826 220.181 219.531 220.101 219.23 220.101C218.93 220.101 218.634 220.181 218.375 220.333L213.02 222.448C212.574 222.713 212.753 224.283 213.202 224.543Z",
    fill: "url(#paint70_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.202 223.465L219.007 226.744C219.226 226.872 219.474 226.939 219.728 226.939C219.981 226.939 220.23 226.872 220.449 226.744L225.699 223.658C225.808 223.596 225.898 223.505 225.961 223.397C226.024 223.288 226.057 223.165 226.057 223.04C226.057 222.914 226.024 222.791 225.961 222.683C225.898 222.574 225.808 222.484 225.699 222.421L220.091 219.254C219.831 219.103 219.535 219.024 219.235 219.024C218.934 219.024 218.639 219.103 218.379 219.254L213.202 222.297C213.099 222.356 213.014 222.441 212.955 222.543C212.896 222.646 212.864 222.762 212.864 222.881C212.864 222.999 212.896 223.115 212.955 223.218C213.014 223.32 213.099 223.405 213.202 223.465Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.204 223.406L219.008 226.686C219.227 226.813 219.476 226.88 219.73 226.88C219.983 226.88 220.232 226.813 220.451 226.686L225.701 223.6C225.807 223.538 225.894 223.449 225.954 223.342C226.014 223.235 226.045 223.115 226.043 222.992C226.043 222.992 226.043 222.992 226.043 222.978C226.057 223.112 226.031 223.248 225.97 223.369C225.909 223.489 225.814 223.59 225.697 223.658L220.447 226.744C220.228 226.872 219.979 226.939 219.726 226.939C219.472 226.939 219.223 226.872 219.004 226.744L213.199 223.465C213.087 223.4 212.997 223.304 212.939 223.19C212.88 223.075 212.856 222.945 212.87 222.817V222.83C212.869 222.947 212.899 223.062 212.958 223.163C213.017 223.265 213.101 223.349 213.204 223.406Z",
    fill: "url(#paint71_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.38 218.267L208.185 221.547C208.404 221.674 208.652 221.742 208.906 221.742C209.159 221.742 209.408 221.674 209.627 221.547L214.88 218.461C215.353 218.182 215.465 216.508 214.99 216.233L209.262 214.057C209.003 213.905 208.707 213.825 208.407 213.825C208.106 213.825 207.811 213.905 207.551 214.057L202.196 216.172C201.752 216.437 201.938 218.007 202.38 218.267Z",
    fill: "url(#paint72_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.382 217.188L208.187 220.468C208.405 220.596 208.654 220.663 208.908 220.663C209.161 220.663 209.41 220.596 209.629 220.468L214.882 217.382C214.99 217.319 215.079 217.229 215.142 217.12C215.204 217.012 215.237 216.889 215.237 216.764C215.237 216.639 215.204 216.516 215.142 216.407C215.079 216.299 214.99 216.208 214.882 216.145L209.27 212.978C209.011 212.827 208.715 212.747 208.415 212.747C208.114 212.747 207.819 212.827 207.559 212.978L202.382 216.02C202.279 216.079 202.194 216.164 202.135 216.267C202.076 216.37 202.044 216.486 202.044 216.604C202.044 216.723 202.076 216.839 202.135 216.941C202.194 217.044 202.279 217.129 202.382 217.188Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.382 217.128L208.187 220.408C208.406 220.535 208.654 220.602 208.908 220.602C209.161 220.602 209.41 220.535 209.629 220.408L214.882 217.322C214.987 217.259 215.074 217.17 215.134 217.064C215.194 216.957 215.225 216.836 215.223 216.714C215.223 216.714 215.223 216.714 215.223 216.699C215.237 216.834 215.212 216.97 215.151 217.09C215.089 217.211 214.994 217.312 214.877 217.38L209.625 220.466C209.406 220.593 209.157 220.661 208.904 220.661C208.65 220.661 208.402 220.593 208.183 220.466L202.378 217.186C202.266 217.122 202.175 217.026 202.117 216.911C202.058 216.796 202.034 216.667 202.048 216.539V216.551C202.047 216.668 202.078 216.783 202.136 216.885C202.195 216.986 202.28 217.07 202.382 217.128Z",
    fill: "url(#paint73_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.558 211.991L197.363 215.271C197.582 215.398 197.831 215.465 198.084 215.465C198.338 215.465 198.586 215.398 198.805 215.271L204.056 212.185C204.529 211.905 204.644 210.231 204.168 209.957L198.44 207.78C198.181 207.629 197.886 207.55 197.585 207.55C197.284 207.55 196.989 207.629 196.729 207.78L191.374 209.896C190.93 210.16 191.11 211.731 191.558 211.991Z",
    fill: "url(#paint74_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.56 210.912L197.365 214.192C197.584 214.319 197.833 214.386 198.086 214.386C198.34 214.386 198.588 214.319 198.807 214.192L204.06 211.106C204.168 211.043 204.258 210.953 204.32 210.845C204.383 210.736 204.415 210.613 204.415 210.488C204.415 210.364 204.383 210.241 204.32 210.132C204.258 210.024 204.168 209.934 204.06 209.871L198.449 206.704C198.189 206.553 197.894 206.473 197.593 206.473C197.293 206.473 196.998 206.553 196.738 206.704L191.56 209.746C191.458 209.805 191.373 209.891 191.314 209.993C191.256 210.095 191.225 210.211 191.225 210.329C191.225 210.447 191.256 210.563 191.314 210.665C191.373 210.768 191.458 210.853 191.56 210.912Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.56 210.854L197.365 214.134C197.583 214.261 197.833 214.328 198.086 214.328C198.339 214.328 198.588 214.261 198.807 214.134L204.058 211.047C204.163 210.986 204.25 210.897 204.31 210.79C204.37 210.684 204.401 210.564 204.399 210.441C204.399 210.441 204.399 210.442 204.399 210.427C204.413 210.562 204.388 210.697 204.326 210.818C204.265 210.939 204.17 211.04 204.053 211.108L198.803 214.194C198.584 214.321 198.335 214.389 198.082 214.389C197.828 214.389 197.579 214.321 197.361 214.194L191.556 210.914C191.444 210.85 191.354 210.754 191.295 210.639C191.237 210.524 191.213 210.395 191.226 210.267C191.226 210.267 191.226 210.267 191.226 210.279C191.226 210.396 191.256 210.511 191.315 210.612C191.373 210.713 191.458 210.796 191.56 210.854Z",
    fill: "url(#paint75_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.738 205.713L186.543 208.992C186.762 209.12 187.011 209.187 187.264 209.187C187.518 209.187 187.766 209.12 187.985 208.992L193.236 205.906C193.709 205.627 193.824 203.953 193.348 203.678L187.623 201.502C187.363 201.351 187.068 201.271 186.767 201.271C186.466 201.271 186.171 201.351 185.911 201.502L180.557 203.618C180.111 203.884 180.29 205.455 180.738 205.713Z",
    fill: "url(#paint76_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.74 204.636L186.545 207.916C186.764 208.043 187.013 208.11 187.266 208.11C187.52 208.11 187.769 208.043 187.988 207.916L193.24 204.83C193.349 204.767 193.439 204.677 193.501 204.568C193.564 204.46 193.597 204.337 193.597 204.211C193.597 204.086 193.564 203.963 193.501 203.854C193.439 203.746 193.349 203.655 193.24 203.593L187.629 200.425C187.369 200.274 187.074 200.195 186.773 200.195C186.473 200.195 186.178 200.274 185.918 200.425L180.74 203.468C180.638 203.527 180.552 203.612 180.493 203.715C180.434 203.817 180.403 203.933 180.403 204.052C180.403 204.17 180.434 204.287 180.493 204.389C180.552 204.492 180.638 204.577 180.74 204.636Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.74 204.578L186.545 207.857C186.764 207.985 187.013 208.052 187.266 208.052C187.52 208.052 187.768 207.985 187.987 207.857L193.24 204.771C193.345 204.709 193.432 204.62 193.492 204.513C193.552 204.406 193.583 204.286 193.581 204.163C193.581 204.163 193.581 204.163 193.581 204.149C193.596 204.283 193.571 204.419 193.51 204.54C193.449 204.66 193.355 204.761 193.238 204.83L187.985 207.916C187.766 208.043 187.517 208.11 187.264 208.11C187.01 208.11 186.762 208.043 186.543 207.916L180.738 204.636C180.626 204.571 180.536 204.476 180.477 204.361C180.419 204.246 180.395 204.116 180.409 203.988C180.409 203.988 180.409 203.988 180.409 204.001C180.408 204.118 180.438 204.233 180.496 204.334C180.554 204.436 180.639 204.52 180.74 204.578Z",
    fill: "url(#paint77_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.918 199.439L175.723 202.718C175.942 202.846 176.191 202.913 176.444 202.913C176.697 202.913 176.946 202.846 177.165 202.718L182.418 199.632C182.891 199.355 183.004 197.679 182.528 197.404L176.8 195.228C176.541 195.077 176.245 194.997 175.945 194.997C175.644 194.997 175.349 195.077 175.089 195.228L169.734 197.344C169.288 197.608 169.466 199.178 169.918 199.439Z",
    fill: "url(#paint78_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.918 198.36L175.723 201.64C175.942 201.767 176.191 201.834 176.444 201.834C176.698 201.834 176.947 201.767 177.165 201.64L182.418 198.553C182.526 198.491 182.616 198.4 182.678 198.292C182.741 198.184 182.774 198.061 182.774 197.936C182.774 197.811 182.741 197.688 182.678 197.58C182.616 197.472 182.526 197.382 182.418 197.319L176.807 194.151C176.547 194 176.252 193.921 175.951 193.921C175.651 193.921 175.355 194 175.096 194.151L169.918 197.194C169.816 197.253 169.731 197.338 169.673 197.441C169.614 197.543 169.583 197.659 169.583 197.777C169.583 197.895 169.614 198.011 169.673 198.113C169.731 198.215 169.816 198.301 169.918 198.36Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.918 198.302L175.723 201.581C175.942 201.708 176.191 201.776 176.444 201.776C176.697 201.776 176.946 201.708 177.165 201.581L182.416 198.495C182.521 198.433 182.608 198.344 182.668 198.237C182.728 198.13 182.759 198.01 182.758 197.887C182.758 197.887 182.758 197.887 182.758 197.873C182.772 198.008 182.747 198.144 182.685 198.265C182.624 198.386 182.529 198.487 182.412 198.555L177.161 201.642C176.942 201.769 176.693 201.836 176.44 201.836C176.187 201.836 175.938 201.769 175.719 201.642L169.914 198.362C169.802 198.298 169.711 198.202 169.653 198.087C169.594 197.972 169.571 197.843 169.584 197.714C169.584 197.714 169.584 197.714 169.584 197.727C169.584 197.844 169.614 197.959 169.673 198.06C169.732 198.161 169.816 198.244 169.918 198.302Z",
    fill: "url(#paint79_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.096 193.162L164.901 196.442C165.12 196.57 165.369 196.637 165.622 196.637C165.875 196.637 166.124 196.57 166.343 196.442L171.596 193.356C172.069 193.079 172.182 191.403 171.706 191.128L165.98 188.952C165.721 188.8 165.426 188.72 165.125 188.72C164.824 188.72 164.529 188.8 164.269 188.952L158.915 191.067C158.469 191.332 158.648 192.902 159.096 193.162Z",
    fill: "url(#paint80_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.096 192.086L164.901 195.365C165.12 195.493 165.369 195.56 165.622 195.56C165.876 195.56 166.125 195.493 166.343 195.365L171.596 192.28C171.704 192.217 171.794 192.127 171.856 192.018C171.919 191.91 171.952 191.787 171.952 191.662C171.952 191.537 171.919 191.414 171.856 191.306C171.794 191.198 171.704 191.107 171.596 191.045L165.985 187.877C165.725 187.726 165.43 187.646 165.129 187.646C164.829 187.646 164.533 187.726 164.274 187.877L159.096 190.92C158.994 190.979 158.909 191.064 158.851 191.166C158.792 191.269 158.761 191.385 158.761 191.503C158.761 191.621 158.792 191.737 158.851 191.839C158.909 191.941 158.994 192.026 159.096 192.086Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.096 192.025L164.901 195.305C165.12 195.433 165.369 195.5 165.622 195.5C165.876 195.5 166.125 195.433 166.343 195.305L171.596 192.219C171.701 192.156 171.788 192.067 171.848 191.961C171.908 191.854 171.939 191.733 171.938 191.611C171.938 191.611 171.938 191.611 171.938 191.596C171.952 191.731 171.926 191.867 171.865 191.988C171.804 192.108 171.709 192.209 171.592 192.277L166.339 195.363C166.12 195.491 165.871 195.558 165.618 195.558C165.365 195.558 165.116 195.491 164.897 195.363L159.092 192.084C158.98 192.019 158.89 191.924 158.831 191.809C158.773 191.694 158.749 191.564 158.763 191.436C158.763 191.436 158.763 191.436 158.763 191.448C158.762 191.566 158.792 191.681 158.851 191.782C158.909 191.884 158.994 191.968 159.096 192.025Z",
    fill: "url(#paint81_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.274 186.89L154.079 190.17C154.298 190.297 154.547 190.365 154.8 190.365C155.054 190.365 155.303 190.297 155.521 190.17L160.774 187.084C161.247 186.805 161.36 185.131 160.887 184.856L155.159 182.68C154.899 182.529 154.604 182.449 154.303 182.449C154.003 182.449 153.707 182.529 153.448 182.68L148.093 184.795C147.647 185.056 147.826 186.626 148.274 186.89Z",
    fill: "url(#paint82_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.274 185.808L154.079 189.087C154.298 189.215 154.547 189.282 154.8 189.282C155.054 189.282 155.303 189.215 155.522 189.087L160.772 186.001C160.88 185.938 160.97 185.848 161.032 185.739C161.094 185.631 161.127 185.508 161.127 185.383C161.127 185.257 161.094 185.135 161.032 185.026C160.97 184.918 160.88 184.827 160.772 184.764L155.161 181.597C154.901 181.446 154.606 181.366 154.305 181.366C154.005 181.366 153.709 181.446 153.45 181.597L148.272 184.639C148.17 184.699 148.085 184.784 148.026 184.887C147.967 184.989 147.936 185.106 147.936 185.224C147.936 185.342 147.967 185.459 148.027 185.561C148.086 185.663 148.172 185.749 148.274 185.808Z",
    fill: "url(#paint83_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.274 185.749L154.079 189.029C154.298 189.156 154.547 189.224 154.8 189.224C155.054 189.224 155.303 189.156 155.521 189.029L160.772 185.943C160.878 185.881 160.965 185.792 161.025 185.685C161.085 185.578 161.116 185.457 161.114 185.335C161.114 185.335 161.114 185.335 161.114 185.32C161.128 185.455 161.103 185.591 161.041 185.712C160.98 185.832 160.885 185.933 160.768 186.001L155.517 189.087C155.298 189.214 155.049 189.282 154.796 189.282C154.543 189.282 154.294 189.214 154.075 189.087L148.27 185.807C148.158 185.743 148.068 185.647 148.009 185.532C147.951 185.417 147.927 185.288 147.941 185.16C147.941 185.16 147.941 185.16 147.941 185.172C147.94 185.289 147.97 185.405 148.029 185.506C148.087 185.608 148.172 185.691 148.274 185.749Z",
    fill: "url(#paint84_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.454 180.61L143.259 183.89C143.478 184.017 143.727 184.084 143.981 184.084C144.234 184.084 144.483 184.017 144.702 183.89L149.954 180.804C150.427 180.525 150.542 178.85 150.067 178.576L144.339 176.4C144.079 176.248 143.784 176.169 143.483 176.169C143.183 176.169 142.887 176.248 142.628 176.4L137.273 178.515C136.827 178.78 137.006 180.35 137.454 180.61Z",
    fill: "url(#paint85_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.455 179.531L143.26 182.811C143.478 182.938 143.727 183.006 143.981 183.006C144.234 183.006 144.483 182.938 144.702 182.811L149.954 179.725C150.063 179.662 150.153 179.572 150.216 179.464C150.279 179.355 150.312 179.232 150.312 179.107C150.312 178.981 150.279 178.858 150.216 178.749C150.153 178.641 150.063 178.551 149.954 178.488L144.343 175.321C144.084 175.17 143.788 175.09 143.488 175.09C143.187 175.09 142.892 175.17 142.632 175.321L137.455 178.363C137.352 178.422 137.267 178.508 137.208 178.61C137.148 178.713 137.117 178.829 137.117 178.947C137.117 179.066 137.148 179.182 137.208 179.285C137.267 179.387 137.352 179.472 137.455 179.531Z",
    fill: "url(#paint86_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.455 179.473L143.26 182.753C143.478 182.88 143.727 182.947 143.981 182.947C144.234 182.947 144.483 182.88 144.702 182.753L149.954 179.667C150.06 179.604 150.147 179.515 150.207 179.408C150.267 179.302 150.298 179.181 150.296 179.059C150.296 179.059 150.296 179.059 150.296 179.044C150.311 179.179 150.286 179.315 150.225 179.436C150.164 179.557 150.069 179.658 149.952 179.727L144.7 182.813C144.481 182.941 144.232 183.008 143.979 183.008C143.725 183.008 143.476 182.941 143.257 182.813L137.453 179.533C137.341 179.469 137.25 179.374 137.191 179.259C137.133 179.144 137.109 179.014 137.123 178.886C137.123 178.886 137.123 178.886 137.123 178.898C137.122 179.015 137.153 179.129 137.211 179.23C137.269 179.331 137.353 179.415 137.455 179.473Z",
    fill: "url(#paint87_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.345 179.727L123.15 183.007C123.368 183.134 123.617 183.202 123.871 183.202C124.124 183.202 124.373 183.134 124.592 183.007L139.132 174.529C139.605 174.253 139.718 172.576 139.245 172.301L133.517 170.125C133.257 169.974 132.962 169.894 132.661 169.894C132.361 169.894 132.065 169.974 131.806 170.125L117.161 177.634C116.715 177.897 116.894 179.467 117.345 179.727Z",
    fill: "url(#paint88_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.342 178.648L123.147 181.928C123.366 182.056 123.615 182.123 123.868 182.123C124.122 182.123 124.371 182.056 124.59 181.928L139.13 173.451C139.239 173.388 139.329 173.298 139.392 173.189C139.454 173.081 139.487 172.958 139.487 172.832C139.487 172.707 139.454 172.584 139.392 172.475C139.329 172.367 139.239 172.277 139.13 172.214L133.519 169.047C133.259 168.895 132.964 168.816 132.663 168.816C132.363 168.816 132.067 168.895 131.808 169.047L117.34 177.48C117.238 177.54 117.153 177.625 117.094 177.728C117.035 177.83 117.004 177.946 117.004 178.065C117.004 178.183 117.036 178.299 117.095 178.402C117.154 178.504 117.24 178.589 117.342 178.648Z",
    fill: "url(#paint89_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.342 178.59L123.147 181.87C123.366 181.997 123.615 182.064 123.868 182.064C124.122 182.064 124.37 181.997 124.589 181.87L139.13 173.393C139.236 173.33 139.323 173.241 139.383 173.135C139.443 173.028 139.473 172.907 139.472 172.785V172.77C139.485 172.904 139.46 173.04 139.399 173.161C139.337 173.282 139.243 173.382 139.126 173.451L124.585 181.928C124.366 182.055 124.117 182.122 123.864 182.122C123.611 182.122 123.362 182.055 123.143 181.928L117.338 178.648C117.226 178.584 117.136 178.488 117.077 178.373C117.019 178.258 116.995 178.129 117.009 178.001C117.009 178.001 117.009 178.001 117.009 178.013C117.008 178.13 117.038 178.245 117.097 178.347C117.156 178.448 117.24 178.532 117.342 178.59Z",
    fill: "url(#paint90_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.555 242.485L231.36 245.764C231.579 245.892 231.828 245.959 232.082 245.959C232.335 245.959 232.584 245.892 232.803 245.764L238.053 242.678C238.526 242.401 238.639 240.725 238.166 240.45L232.44 238.274C232.18 238.123 231.885 238.043 231.584 238.043C231.284 238.043 230.989 238.123 230.729 238.274L225.374 240.39C224.926 240.656 225.107 242.227 225.555 242.485Z",
    fill: "url(#paint91_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.564 241.408L231.369 244.688C231.588 244.815 231.837 244.883 232.09 244.883C232.344 244.883 232.593 244.815 232.811 244.688L238.064 241.602C238.172 241.539 238.262 241.449 238.324 241.34C238.386 241.232 238.42 241.109 238.42 240.984C238.42 240.859 238.386 240.737 238.324 240.628C238.262 240.52 238.172 240.43 238.064 240.367L232.453 237.2C232.193 237.049 231.898 236.969 231.597 236.969C231.297 236.969 231.001 237.049 230.742 237.2L225.564 240.242C225.462 240.301 225.377 240.387 225.318 240.489C225.259 240.591 225.229 240.707 225.229 240.825C225.229 240.943 225.259 241.059 225.318 241.161C225.377 241.264 225.462 241.349 225.564 241.408Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.556 241.35L231.361 244.629C231.579 244.757 231.828 244.824 232.082 244.824C232.335 244.824 232.584 244.757 232.803 244.629L238.053 241.544C238.159 241.482 238.246 241.393 238.306 241.286C238.366 241.18 238.397 241.06 238.395 240.938C238.396 240.932 238.396 240.926 238.395 240.921C238.409 241.055 238.384 241.191 238.323 241.312C238.261 241.433 238.166 241.534 238.049 241.602L232.799 244.688C232.58 244.815 232.331 244.882 232.078 244.882C231.824 244.882 231.575 244.815 231.356 244.688L225.552 241.408C225.44 241.344 225.349 241.248 225.291 241.133C225.232 241.018 225.208 240.889 225.222 240.76C225.222 240.765 225.222 240.769 225.222 240.773C225.221 240.89 225.251 241.005 225.31 241.107C225.369 241.208 225.454 241.292 225.556 241.35Z",
    fill: "url(#paint92_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.736 236.208L220.541 239.488C220.759 239.616 221.008 239.683 221.262 239.683C221.515 239.683 221.764 239.616 221.983 239.488L227.236 236.402C227.709 236.123 227.821 234.449 227.346 234.174L221.618 231.998C221.358 231.847 221.063 231.767 220.762 231.767C220.462 231.767 220.167 231.847 219.907 231.998L214.552 234.114C214.106 234.38 214.287 235.95 214.736 236.208Z",
    fill: "url(#paint93_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.734 235.132L220.539 238.412C220.757 238.539 221.006 238.607 221.26 238.607C221.513 238.607 221.762 238.539 221.981 238.412L227.234 235.325C227.342 235.263 227.432 235.173 227.495 235.064C227.558 234.956 227.591 234.832 227.591 234.707C227.591 234.582 227.558 234.459 227.495 234.35C227.432 234.242 227.342 234.151 227.234 234.089L221.622 230.921C221.363 230.77 221.067 230.691 220.767 230.691C220.466 230.691 220.171 230.77 219.911 230.921L214.734 233.964C214.631 234.023 214.546 234.108 214.487 234.211C214.428 234.313 214.396 234.429 214.396 234.548C214.396 234.666 214.428 234.782 214.487 234.885C214.546 234.987 214.631 235.073 214.734 235.132Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.734 235.074L220.539 238.353C220.757 238.481 221.006 238.548 221.26 238.548C221.513 238.548 221.762 238.481 221.981 238.353L227.232 235.267C227.337 235.205 227.424 235.116 227.484 235.009C227.544 234.902 227.575 234.782 227.573 234.659C227.573 234.659 227.573 234.659 227.573 234.645C227.587 234.779 227.562 234.915 227.501 235.036C227.439 235.157 227.344 235.257 227.227 235.325L221.977 238.412C221.758 238.539 221.509 238.606 221.256 238.606C221.002 238.606 220.753 238.539 220.534 238.412L214.73 235.132C214.618 235.067 214.527 234.972 214.469 234.857C214.41 234.742 214.387 234.613 214.4 234.484C214.4 234.484 214.4 234.484 214.4 234.497C214.399 234.614 214.43 234.729 214.488 234.831C214.547 234.932 214.632 235.016 214.734 235.074Z",
    fill: "url(#paint94_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.914 229.934L209.719 233.214C209.937 233.342 210.186 233.409 210.44 233.409C210.693 233.409 210.942 233.342 211.161 233.214L216.414 230.128C216.887 229.851 216.999 228.175 216.524 227.9L210.798 225.724C210.539 225.573 210.243 225.493 209.943 225.493C209.642 225.493 209.347 225.573 209.087 225.724L203.732 227.84C203.284 228.104 203.466 229.674 203.914 229.934Z",
    fill: "url(#paint95_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.912 228.856L209.716 232.135C209.935 232.263 210.184 232.33 210.438 232.33C210.691 232.33 210.94 232.263 211.159 232.135L216.411 229.05C216.52 228.987 216.609 228.897 216.672 228.788C216.734 228.68 216.767 228.557 216.767 228.432C216.767 228.307 216.734 228.184 216.672 228.076C216.609 227.968 216.52 227.878 216.411 227.815L210.8 224.647C210.541 224.496 210.245 224.416 209.945 224.416C209.644 224.416 209.349 224.496 209.089 224.647L203.912 227.69C203.81 227.749 203.725 227.834 203.666 227.936C203.607 228.039 203.576 228.155 203.576 228.273C203.576 228.391 203.607 228.507 203.666 228.609C203.725 228.711 203.81 228.796 203.912 228.856Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.914 228.797L209.719 232.077C209.938 232.205 210.186 232.272 210.44 232.272C210.693 232.272 210.942 232.205 211.161 232.077L216.414 228.991C216.519 228.929 216.606 228.84 216.666 228.733C216.726 228.626 216.757 228.505 216.755 228.383C216.755 228.383 216.755 228.383 216.755 228.369C216.769 228.503 216.744 228.639 216.683 228.759C216.622 228.88 216.528 228.981 216.412 229.05L211.159 232.135C210.94 232.263 210.691 232.33 210.438 232.33C210.184 232.33 209.936 232.263 209.717 232.135L203.912 228.856C203.8 228.791 203.709 228.696 203.651 228.581C203.592 228.466 203.569 228.336 203.582 228.208C203.582 228.208 203.582 228.208 203.582 228.221C203.582 228.337 203.612 228.452 203.67 228.554C203.728 228.655 203.812 228.739 203.914 228.797Z",
    fill: "url(#paint96_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.092 223.656L198.897 226.936C199.116 227.063 199.365 227.13 199.618 227.13C199.871 227.13 200.12 227.063 200.339 226.936L205.59 223.85C206.063 223.573 206.177 221.897 205.702 221.622L199.977 219.446C199.717 219.294 199.422 219.215 199.121 219.215C198.82 219.215 198.525 219.294 198.265 219.446L192.911 221.561C192.463 221.828 192.644 223.406 193.092 223.656Z",
    fill: "url(#paint97_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.09 222.58L198.895 225.859C199.114 225.987 199.362 226.054 199.616 226.054C199.869 226.054 200.118 225.987 200.337 225.859L205.59 222.773C205.698 222.71 205.787 222.62 205.85 222.511C205.912 222.403 205.945 222.28 205.945 222.155C205.945 222.03 205.912 221.907 205.85 221.798C205.787 221.69 205.698 221.599 205.59 221.536L199.979 218.369C199.719 218.218 199.424 218.138 199.123 218.138C198.822 218.138 198.527 218.218 198.267 218.369L193.09 221.411C192.987 221.471 192.902 221.556 192.843 221.658C192.784 221.761 192.752 221.877 192.752 221.995C192.752 222.114 192.784 222.23 192.843 222.333C192.902 222.435 192.987 222.52 193.09 222.58Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.092 222.521L198.897 225.801C199.116 225.928 199.365 225.996 199.618 225.996C199.871 225.996 200.12 225.928 200.339 225.801L205.592 222.715C205.697 222.653 205.784 222.564 205.844 222.457C205.905 222.35 205.935 222.229 205.934 222.107C205.934 222.107 205.934 222.107 205.934 222.092C205.947 222.227 205.922 222.363 205.861 222.483C205.799 222.604 205.704 222.705 205.588 222.773L200.335 225.859C200.116 225.987 199.867 226.054 199.614 226.054C199.36 226.054 199.111 225.987 198.893 225.859L193.088 222.58C192.976 222.515 192.885 222.42 192.826 222.305C192.768 222.19 192.744 222.06 192.758 221.932V221.944C192.757 222.061 192.788 222.177 192.846 222.278C192.905 222.38 192.99 222.464 193.092 222.521Z",
    fill: "url(#paint98_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.27 217.382L188.075 220.662C188.294 220.789 188.542 220.856 188.796 220.856C189.049 220.856 189.298 220.789 189.517 220.662L194.77 217.576C195.243 217.299 195.355 215.622 194.882 215.347L189.154 213.172C188.895 213.02 188.599 212.941 188.299 212.941C187.998 212.941 187.703 213.02 187.443 213.172L182.088 215.287C181.64 215.552 181.822 217.122 182.27 217.382Z",
    fill: "url(#paint99_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.272 216.305L188.077 219.585C188.296 219.713 188.545 219.779 188.798 219.779C189.051 219.779 189.3 219.713 189.519 219.585L194.772 216.499C194.88 216.436 194.969 216.346 195.032 216.237C195.094 216.129 195.127 216.006 195.127 215.881C195.127 215.756 195.094 215.633 195.032 215.524C194.969 215.416 194.88 215.325 194.772 215.262L189.161 212.095C188.901 211.944 188.606 211.864 188.305 211.864C188.004 211.864 187.709 211.944 187.449 212.095L182.272 215.137C182.169 215.196 182.084 215.282 182.025 215.384C181.966 215.487 181.935 215.603 181.935 215.721C181.935 215.84 181.966 215.956 182.025 216.059C182.084 216.161 182.169 216.246 182.272 216.305Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.274 216.245L188.079 219.525C188.298 219.652 188.547 219.719 188.8 219.719C189.054 219.719 189.303 219.652 189.521 219.525L194.772 216.439C194.878 216.376 194.965 216.287 195.025 216.181C195.085 216.074 195.115 215.953 195.114 215.831C195.114 215.831 195.114 215.831 195.114 215.816C195.128 215.951 195.102 216.086 195.041 216.207C194.98 216.328 194.885 216.429 194.768 216.497L189.517 219.583C189.298 219.71 189.049 219.777 188.796 219.777C188.543 219.777 188.294 219.71 188.075 219.583L182.27 216.303C182.158 216.239 182.068 216.143 182.009 216.028C181.951 215.913 181.927 215.784 181.941 215.656C181.941 215.656 181.941 215.656 181.941 215.668C181.94 215.785 181.97 215.901 182.029 216.002C182.087 216.104 182.172 216.187 182.274 216.245Z",
    fill: "url(#paint100_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.448 211.104L177.253 214.383C177.472 214.511 177.721 214.578 177.974 214.578C178.228 214.578 178.476 214.511 178.695 214.383L183.948 211.297C184.421 211.02 184.534 209.344 184.058 209.069L178.333 206.893C178.073 206.742 177.778 206.662 177.477 206.662C177.176 206.662 176.881 206.742 176.621 206.893L171.267 209.009C170.821 209.275 171 210.848 171.448 211.104Z",
    fill: "url(#paint101_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.45 210.027L177.255 213.307C177.474 213.434 177.723 213.502 177.976 213.502C178.23 213.502 178.479 213.434 178.697 213.307L183.95 210.221C184.058 210.158 184.148 210.068 184.21 209.959C184.273 209.851 184.305 209.728 184.305 209.603C184.305 209.478 184.273 209.356 184.21 209.247C184.148 209.139 184.058 209.049 183.95 208.986L178.341 205.819C178.081 205.667 177.786 205.588 177.486 205.588C177.185 205.588 176.89 205.667 176.63 205.819L171.452 208.861C171.35 208.92 171.265 209.005 171.206 209.107C171.147 209.21 171.116 209.325 171.116 209.443C171.116 209.561 171.146 209.678 171.205 209.78C171.264 209.882 171.348 209.968 171.45 210.027Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.45 209.977L177.255 213.257C177.474 213.384 177.723 213.452 177.976 213.452C178.229 213.452 178.478 213.384 178.697 213.257L183.95 210.171C184.055 210.109 184.143 210.019 184.203 209.913C184.263 209.806 184.293 209.685 184.292 209.563C184.292 209.563 184.292 209.563 184.292 209.548C184.305 209.683 184.28 209.819 184.219 209.939C184.158 210.06 184.063 210.161 183.946 210.229L178.693 213.315C178.474 213.443 178.225 213.51 177.972 213.51C177.719 213.51 177.47 213.443 177.251 213.315L171.446 210.035C171.334 209.971 171.243 209.876 171.185 209.761C171.126 209.646 171.103 209.516 171.117 209.388C171.117 209.388 171.117 209.388 171.117 209.401C171.116 209.518 171.146 209.633 171.204 209.734C171.263 209.836 171.348 209.92 171.45 209.977Z",
    fill: "url(#paint102_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.63 204.83L166.435 208.11C166.654 208.237 166.903 208.304 167.156 208.304C167.41 208.304 167.658 208.237 167.877 208.11L173.128 205.023C173.601 204.746 173.714 203.07 173.238 202.795L167.513 200.619C167.253 200.468 166.958 200.388 166.657 200.388C166.357 200.388 166.061 200.468 165.802 200.619L160.447 202.735C160.005 203.01 160.18 204.571 160.63 204.83Z",
    fill: "url(#paint103_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.618 203.753L166.423 207.033C166.642 207.16 166.891 207.227 167.144 207.227C167.397 207.227 167.646 207.16 167.865 207.033L173.118 203.947C173.225 203.884 173.315 203.793 173.377 203.685C173.439 203.577 173.471 203.454 173.471 203.329C173.471 203.205 173.439 203.082 173.377 202.974C173.315 202.866 173.225 202.775 173.118 202.712L167.507 199.545C167.247 199.393 166.952 199.314 166.651 199.314C166.35 199.314 166.055 199.393 165.795 199.545L160.618 202.587C160.516 202.646 160.431 202.731 160.372 202.834C160.313 202.936 160.282 203.052 160.282 203.17C160.282 203.288 160.313 203.404 160.372 203.506C160.431 203.609 160.516 203.694 160.618 203.753Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.628 203.693L166.431 206.973C166.65 207.1 166.899 207.167 167.152 207.167C167.406 207.167 167.655 207.1 167.874 206.973L173.124 203.886C173.23 203.824 173.317 203.735 173.377 203.628C173.437 203.522 173.467 203.401 173.466 203.278C173.466 203.278 173.466 203.278 173.466 203.264C173.48 203.399 173.454 203.534 173.393 203.655C173.332 203.776 173.237 203.876 173.12 203.945L167.867 207.031C167.648 207.158 167.399 207.225 167.146 207.225C166.893 207.225 166.644 207.158 166.425 207.031L160.622 203.751C160.51 203.687 160.42 203.591 160.361 203.476C160.303 203.361 160.279 203.232 160.293 203.104C160.293 203.104 160.293 203.103 160.293 203.116C160.292 203.233 160.323 203.349 160.382 203.45C160.441 203.551 160.526 203.635 160.628 203.693Z",
    fill: "url(#paint104_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.806 198.554L155.611 201.833C155.83 201.961 156.079 202.028 156.332 202.028C156.586 202.028 156.835 201.961 157.054 201.833L162.306 198.747C162.779 198.47 162.892 196.794 162.419 196.519L156.691 194.343C156.431 194.192 156.136 194.112 155.835 194.112C155.535 194.112 155.24 194.192 154.98 194.343L149.625 196.459C149.177 196.723 149.358 198.289 149.806 198.554Z",
    fill: "url(#paint105_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.806 197.477L155.611 200.757C155.83 200.884 156.079 200.951 156.332 200.951C156.586 200.951 156.835 200.884 157.054 200.757L162.306 197.671C162.414 197.608 162.504 197.518 162.567 197.409C162.629 197.301 162.662 197.178 162.662 197.053C162.662 196.928 162.629 196.806 162.567 196.697C162.504 196.589 162.414 196.499 162.306 196.436L156.695 193.269C156.435 193.117 156.14 193.038 155.84 193.038C155.539 193.038 155.244 193.117 154.984 193.269L149.806 196.311C149.704 196.37 149.62 196.455 149.561 196.558C149.502 196.66 149.471 196.776 149.471 196.894C149.471 197.012 149.502 197.128 149.561 197.23C149.62 197.333 149.704 197.418 149.806 197.477Z",
    fill: "url(#paint106_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.802 197.419L155.607 200.698C155.826 200.826 156.075 200.893 156.328 200.893C156.582 200.893 156.83 200.826 157.049 200.698L162.3 197.613C162.406 197.55 162.493 197.461 162.553 197.354C162.613 197.247 162.643 197.127 162.642 197.004C162.642 197.004 162.642 197.004 162.642 196.99C162.655 197.124 162.63 197.26 162.569 197.381C162.508 197.502 162.413 197.602 162.296 197.671L157.045 200.757C156.826 200.884 156.577 200.951 156.324 200.951C156.071 200.951 155.822 200.884 155.603 200.757L149.798 197.477C149.686 197.413 149.595 197.317 149.537 197.202C149.478 197.087 149.455 196.958 149.469 196.829C149.469 196.829 149.469 196.83 149.469 196.842C149.468 196.959 149.498 197.074 149.557 197.176C149.615 197.277 149.7 197.361 149.802 197.419Z",
    fill: "url(#paint107_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.987 192.277L144.792 195.557C145.011 195.684 145.259 195.752 145.513 195.752C145.766 195.752 146.015 195.684 146.234 195.557L151.484 192.471C151.957 192.192 152.072 190.518 151.597 190.243L145.869 188.067C145.609 187.916 145.314 187.836 145.013 187.836C144.713 187.836 144.418 187.916 144.158 188.067L138.803 190.185C138.359 190.449 138.538 192.017 138.987 192.277Z",
    fill: "url(#paint108_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.986 191.199L144.791 194.478C145.01 194.606 145.259 194.673 145.513 194.673C145.766 194.673 146.015 194.606 146.234 194.478L151.486 191.392C151.594 191.329 151.684 191.239 151.746 191.131C151.809 191.023 151.842 190.9 151.842 190.775C151.842 190.65 151.809 190.527 151.746 190.419C151.684 190.31 151.594 190.22 151.486 190.157L145.875 186.99C145.615 186.839 145.32 186.759 145.019 186.759C144.719 186.759 144.423 186.839 144.164 186.99L138.986 190.033C138.884 190.092 138.8 190.177 138.741 190.279C138.682 190.382 138.651 190.497 138.651 190.616C138.651 190.734 138.682 190.849 138.741 190.952C138.8 191.054 138.884 191.139 138.986 191.199Z",
    fill: "url(#paint109_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.987 191.14L144.792 194.42C145.01 194.547 145.259 194.615 145.513 194.615C145.766 194.615 146.015 194.547 146.234 194.42L151.486 191.334C151.592 191.272 151.679 191.183 151.739 191.076C151.799 190.969 151.83 190.848 151.828 190.726C151.828 190.726 151.828 190.726 151.828 190.711C151.842 190.846 151.817 190.982 151.756 191.102C151.695 191.223 151.601 191.324 151.484 191.392L146.232 194.478C146.013 194.606 145.764 194.673 145.511 194.673C145.257 194.673 145.008 194.606 144.789 194.478L138.985 191.199C138.873 191.134 138.782 191.039 138.723 190.924C138.665 190.809 138.641 190.679 138.655 190.551C138.655 190.555 138.655 190.559 138.655 190.564C138.654 190.681 138.684 190.795 138.743 190.897C138.801 190.998 138.885 191.082 138.987 191.14Z",
    fill: "url(#paint110_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.158 186.001L133.963 189.281C134.182 189.408 134.431 189.475 134.684 189.475C134.938 189.475 135.186 189.408 135.405 189.281L140.656 186.195C141.129 185.918 141.242 184.242 140.768 183.967L135.041 181.791C134.781 181.639 134.486 181.56 134.185 181.56C133.884 181.56 133.589 181.639 133.329 181.791L127.975 183.906C127.533 184.173 127.716 185.743 128.158 186.001Z",
    fill: "url(#paint111_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.165 184.922L133.969 188.202C134.188 188.33 134.437 188.397 134.691 188.397C134.944 188.397 135.193 188.33 135.412 188.202L140.664 185.116C140.772 185.053 140.862 184.963 140.924 184.854C140.987 184.746 141.019 184.623 141.019 184.498C141.019 184.373 140.987 184.25 140.924 184.141C140.862 184.033 140.772 183.942 140.664 183.879L135.053 180.712C134.793 180.561 134.498 180.481 134.197 180.481C133.897 180.481 133.602 180.561 133.342 180.712L128.165 183.754C128.062 183.814 127.977 183.899 127.917 184.001C127.858 184.104 127.827 184.22 127.827 184.338C127.827 184.457 127.858 184.573 127.917 184.676C127.977 184.778 128.062 184.863 128.165 184.922Z",
    fill: "url(#paint112_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.164 184.86L133.969 188.14C134.188 188.267 134.437 188.334 134.691 188.334C134.944 188.334 135.193 188.267 135.412 188.14L140.662 185.054C140.768 184.992 140.855 184.902 140.915 184.796C140.975 184.689 141.006 184.568 141.004 184.446C141.004 184.446 141.004 184.446 141.004 184.431C141.018 184.566 140.993 184.702 140.932 184.824C140.87 184.945 140.775 185.046 140.658 185.114L135.408 188.2C135.189 188.328 134.94 188.394 134.686 188.394C134.433 188.394 134.184 188.328 133.965 188.2L128.16 184.92C128.048 184.856 127.958 184.761 127.899 184.646C127.841 184.531 127.817 184.401 127.831 184.273C127.831 184.273 127.831 184.273 127.831 184.287C127.831 184.404 127.861 184.518 127.92 184.619C127.979 184.72 128.063 184.803 128.164 184.86Z",
    fill: "url(#paint113_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.265 247.876L222.07 251.155C222.289 251.283 222.538 251.35 222.792 251.35C223.045 251.35 223.294 251.283 223.513 251.155L228.765 248.07C229.238 247.793 229.351 246.116 228.876 245.841L223.15 243.665C222.89 243.514 222.595 243.434 222.294 243.434C221.994 243.434 221.698 243.514 221.439 243.665L216.084 245.781C215.638 246.048 215.817 247.618 216.265 247.876Z",
    fill: "url(#paint114_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.266 246.799L222.071 250.079C222.29 250.206 222.538 250.273 222.792 250.273C223.045 250.273 223.294 250.206 223.513 250.079L228.765 246.993C228.874 246.93 228.963 246.84 229.026 246.732C229.088 246.623 229.121 246.5 229.121 246.375C229.121 246.25 229.088 246.128 229.026 246.019C228.963 245.911 228.874 245.821 228.765 245.758L223.155 242.591C222.895 242.44 222.6 242.36 222.299 242.36C221.998 242.36 221.703 242.44 221.443 242.591L216.266 245.633C216.164 245.693 216.079 245.778 216.02 245.88C215.961 245.982 215.93 246.098 215.93 246.216C215.93 246.334 215.961 246.45 216.02 246.553C216.079 246.655 216.164 246.74 216.266 246.799Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.265 246.741L222.07 250.021C222.289 250.148 222.538 250.215 222.792 250.215C223.045 250.215 223.294 250.148 223.513 250.021L228.765 246.935C228.871 246.872 228.958 246.783 229.018 246.677C229.078 246.57 229.109 246.449 229.107 246.326C229.107 246.326 229.107 246.327 229.107 246.312C229.121 246.447 229.096 246.582 229.035 246.703C228.974 246.824 228.88 246.924 228.763 246.993L223.511 250.079C223.292 250.206 223.043 250.273 222.789 250.273C222.536 250.273 222.287 250.206 222.068 250.079L216.263 246.799C216.152 246.735 216.061 246.639 216.003 246.524C215.944 246.409 215.92 246.28 215.934 246.152C215.934 246.152 215.934 246.152 215.934 246.166C215.933 246.283 215.963 246.398 216.022 246.499C216.08 246.6 216.164 246.683 216.265 246.741Z",
    fill: "url(#paint115_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.446 241.604L211.251 244.883C211.469 245.011 211.718 245.078 211.972 245.078C212.225 245.078 212.474 245.011 212.693 244.883L217.945 241.798C218.418 241.521 218.531 239.844 218.058 239.569L212.33 237.393C212.07 237.242 211.775 237.162 211.474 237.162C211.174 237.162 210.879 237.242 210.619 237.393L205.264 239.509C204.816 239.771 204.997 241.341 205.446 241.604Z",
    fill: "url(#paint116_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.444 240.523L211.249 243.803C211.468 243.93 211.717 243.997 211.97 243.997C212.223 243.997 212.472 243.93 212.691 243.803L217.944 240.717C218.052 240.654 218.142 240.563 218.204 240.455C218.266 240.346 218.299 240.224 218.299 240.099C218.299 239.973 218.266 239.85 218.204 239.742C218.142 239.633 218.052 239.543 217.944 239.48L212.333 236.313C212.073 236.161 211.778 236.082 211.477 236.082C211.176 236.082 210.881 236.161 210.621 236.313L205.444 239.355C205.341 239.414 205.256 239.499 205.197 239.602C205.138 239.704 205.106 239.821 205.106 239.939C205.106 240.058 205.138 240.174 205.197 240.276C205.256 240.379 205.341 240.464 205.444 240.523Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.446 240.465L211.251 243.745C211.47 243.872 211.719 243.939 211.972 243.939C212.225 243.939 212.474 243.872 212.693 243.745L217.946 240.658C218.051 240.596 218.138 240.507 218.199 240.4C218.259 240.294 218.289 240.173 218.288 240.05C218.288 240.05 218.288 240.05 218.288 240.036C218.301 240.171 218.276 240.306 218.215 240.427C218.153 240.548 218.059 240.648 217.942 240.717L212.691 243.803C212.472 243.93 212.223 243.997 211.97 243.997C211.717 243.997 211.468 243.93 211.249 243.803L205.444 240.523C205.332 240.459 205.242 240.363 205.183 240.248C205.125 240.133 205.101 240.004 205.115 239.875C205.115 239.875 205.115 239.875 205.115 239.888C205.113 240.005 205.143 240.12 205.202 240.221C205.26 240.323 205.344 240.407 205.446 240.465Z",
    fill: "url(#paint117_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.622 235.324L200.427 238.603C200.646 238.73 200.895 238.798 201.148 238.798C201.401 238.798 201.65 238.73 201.869 238.603L207.12 235.517C207.593 235.24 207.705 233.564 207.232 233.289L201.504 231.113C201.245 230.962 200.949 230.882 200.649 230.882C200.348 230.882 200.053 230.962 199.793 231.113L194.438 233.229C193.994 233.495 194.174 235.065 194.622 235.324Z",
    fill: "url(#paint118_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.622 234.249L200.427 237.529C200.646 237.656 200.895 237.723 201.148 237.723C201.401 237.723 201.65 237.656 201.869 237.529L207.122 234.443C207.23 234.38 207.321 234.29 207.383 234.181C207.446 234.073 207.479 233.95 207.479 233.824C207.479 233.699 207.446 233.576 207.383 233.467C207.321 233.359 207.23 233.268 207.122 233.206L201.511 230.039C201.251 229.887 200.956 229.807 200.655 229.807C200.354 229.807 200.059 229.887 199.799 230.039L194.622 233.081C194.519 233.14 194.434 233.225 194.375 233.328C194.316 233.43 194.285 233.546 194.285 233.665C194.285 233.783 194.316 233.9 194.375 234.002C194.434 234.105 194.519 234.19 194.622 234.249Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.624 234.189L200.429 237.468C200.648 237.596 200.897 237.663 201.15 237.663C201.404 237.663 201.653 237.596 201.871 237.468L207.122 234.382C207.227 234.32 207.315 234.231 207.375 234.124C207.435 234.017 207.465 233.897 207.464 233.774C207.464 233.774 207.464 233.774 207.464 233.76C207.477 233.894 207.452 234.03 207.391 234.151C207.329 234.271 207.235 234.372 207.118 234.44L201.867 237.527C201.648 237.654 201.399 237.721 201.146 237.721C200.893 237.721 200.644 237.654 200.425 237.527L194.62 234.247C194.508 234.182 194.417 234.087 194.359 233.972C194.3 233.857 194.277 233.727 194.291 233.599C194.29 233.604 194.29 233.609 194.291 233.614C194.29 233.731 194.32 233.846 194.379 233.947C194.438 234.048 194.522 234.131 194.624 234.189Z",
    fill: "url(#paint119_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.446 210.177L189.609 232.329C189.828 232.457 190.077 232.524 190.33 232.524C190.583 232.524 190.832 232.457 191.051 232.329L196.304 229.243C196.777 228.966 196.891 227.29 196.416 227.015L158.333 205.967C158.073 205.815 157.778 205.736 157.478 205.736C157.177 205.736 156.882 205.815 156.622 205.967L151.267 208.082C150.817 208.349 150.998 209.919 151.446 210.177Z",
    fill: "url(#paint120_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.444 209.098L189.605 231.25C189.824 231.378 190.073 231.445 190.326 231.445C190.579 231.445 190.828 231.378 191.047 231.25L196.3 228.164C196.408 228.101 196.498 228.011 196.56 227.903C196.622 227.795 196.655 227.672 196.655 227.547C196.655 227.422 196.622 227.299 196.56 227.191C196.498 227.082 196.408 226.992 196.3 226.929L158.333 204.89C158.074 204.739 157.778 204.659 157.478 204.659C157.177 204.659 156.882 204.739 156.622 204.89L151.444 207.932C151.342 207.992 151.258 208.077 151.199 208.179C151.14 208.282 151.109 208.398 151.109 208.516C151.109 208.634 151.14 208.749 151.199 208.852C151.258 208.954 151.342 209.039 151.444 209.098Z",
    fill: "#9B9ECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.438 209.04L189.598 231.192C189.817 231.32 190.066 231.387 190.319 231.387C190.573 231.387 190.822 231.32 191.041 231.192L196.291 228.106C196.396 228.044 196.483 227.955 196.543 227.849C196.603 227.742 196.634 227.622 196.633 227.5C196.633 227.495 196.633 227.49 196.633 227.486C196.647 227.62 196.621 227.756 196.56 227.877C196.499 227.997 196.404 228.098 196.287 228.167L191.034 231.253C190.816 231.38 190.567 231.447 190.313 231.447C190.06 231.447 189.811 231.38 189.592 231.253L151.432 209.101C151.32 209.036 151.23 208.94 151.171 208.826C151.113 208.711 151.089 208.581 151.102 208.453C151.102 208.457 151.102 208.461 151.102 208.465C151.102 208.582 151.133 208.698 151.192 208.799C151.251 208.9 151.336 208.983 151.438 209.04Z",
    fill: "url(#paint121_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.516 203.947L146.321 207.226C146.54 207.354 146.789 207.421 147.042 207.421C147.296 207.421 147.545 207.354 147.763 207.226L153.016 204.14C153.489 203.863 153.602 202.187 153.126 201.912L147.399 199.736C147.139 199.585 146.844 199.505 146.543 199.505C146.243 199.505 145.947 199.585 145.687 199.736L140.333 201.852C139.887 202.116 140.068 203.689 140.516 203.947Z",
    fill: "url(#paint122_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.516 202.876L146.321 206.156C146.54 206.283 146.789 206.35 147.042 206.35C147.296 206.35 147.545 206.283 147.764 206.156L153.014 203.07C153.122 203.007 153.213 202.917 153.275 202.809C153.338 202.7 153.371 202.577 153.371 202.452C153.371 202.326 153.338 202.203 153.275 202.095C153.213 201.986 153.122 201.896 153.014 201.833L147.403 198.666C147.143 198.515 146.848 198.435 146.547 198.435C146.247 198.435 145.951 198.515 145.692 198.666L140.514 201.708C140.412 201.768 140.327 201.853 140.268 201.955C140.209 202.058 140.178 202.175 140.178 202.293C140.178 202.411 140.209 202.527 140.269 202.63C140.328 202.732 140.413 202.817 140.516 202.876Z",
    fill: "url(#paint123_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.517 202.81L146.321 206.09C146.54 206.217 146.789 206.284 147.043 206.284C147.296 206.284 147.545 206.217 147.764 206.09L153.014 203.003C153.12 202.941 153.207 202.852 153.267 202.745C153.327 202.639 153.358 202.518 153.356 202.395V202.381C153.37 202.516 153.345 202.652 153.284 202.773C153.222 202.894 153.127 202.995 153.01 203.064L147.76 206.15C147.541 206.277 147.292 206.345 147.038 206.345C146.785 206.345 146.536 206.277 146.317 206.15L140.512 202.87C140.401 202.806 140.31 202.71 140.251 202.595C140.193 202.48 140.169 202.351 140.183 202.223C140.183 202.223 140.183 202.222 140.183 202.237C140.183 202.353 140.213 202.468 140.272 202.568C140.331 202.669 140.415 202.752 140.517 202.81Z",
    fill: "url(#paint124_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.696 197.671L135.501 200.95C135.72 201.078 135.969 201.145 136.222 201.145C136.476 201.145 136.725 201.078 136.944 200.95L142.194 197.864C142.667 197.587 142.782 195.911 142.307 195.636L136.579 193.46C136.319 193.309 136.024 193.229 135.723 193.229C135.423 193.229 135.127 193.309 134.868 193.46L129.513 195.576C129.069 195.84 129.242 197.412 129.696 197.671Z",
    fill: "url(#paint125_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.698 196.592L135.503 199.872C135.722 199.999 135.971 200.066 136.224 200.066C136.478 200.066 136.727 199.999 136.946 199.872L142.198 196.785C142.306 196.722 142.396 196.632 142.458 196.524C142.521 196.415 142.553 196.292 142.553 196.167C142.553 196.042 142.521 195.919 142.458 195.811C142.396 195.702 142.306 195.612 142.198 195.549L136.587 192.381C136.327 192.23 136.032 192.15 135.731 192.15C135.431 192.15 135.135 192.23 134.876 192.381L129.698 195.424C129.596 195.483 129.511 195.568 129.451 195.671C129.392 195.773 129.361 195.89 129.361 196.008C129.361 196.126 129.392 196.242 129.451 196.345C129.511 196.447 129.596 196.533 129.698 196.592Z",
    fill: "url(#paint126_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.696 196.533L135.501 199.813C135.72 199.941 135.969 200.008 136.222 200.008C136.476 200.008 136.724 199.941 136.943 199.813L142.196 196.727C142.301 196.665 142.388 196.576 142.448 196.47C142.508 196.364 142.539 196.243 142.538 196.121C142.538 196.121 142.538 196.121 142.538 196.107C142.552 196.241 142.527 196.377 142.466 196.498C142.405 196.618 142.311 196.719 142.194 196.788L136.941 199.874C136.722 200.001 136.474 200.068 136.22 200.068C135.967 200.068 135.718 200.001 135.499 199.874L129.694 196.594C129.582 196.53 129.491 196.434 129.433 196.319C129.374 196.204 129.351 196.075 129.365 195.946C129.365 195.946 129.365 195.946 129.365 195.959C129.364 196.075 129.394 196.19 129.453 196.291C129.511 196.392 129.595 196.476 129.696 196.533Z",
    fill: "url(#paint127_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.874 191.394L124.679 194.674C124.898 194.802 125.147 194.869 125.4 194.869C125.654 194.869 125.903 194.802 126.122 194.674L131.374 191.588C131.847 191.311 131.96 189.635 131.487 189.36L125.759 187.184C125.499 187.033 125.204 186.953 124.903 186.953C124.603 186.953 124.308 187.033 124.048 187.184L118.693 189.3C118.247 189.564 118.426 191.134 118.874 191.394Z",
    fill: "url(#paint128_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.874 190.32L124.679 193.6C124.898 193.727 125.147 193.794 125.4 193.794C125.654 193.794 125.903 193.727 126.122 193.6L131.374 190.514C131.483 190.451 131.573 190.361 131.636 190.252C131.698 190.144 131.731 190.021 131.731 189.895C131.731 189.77 131.698 189.647 131.636 189.538C131.573 189.429 131.483 189.339 131.374 189.277L125.765 186.109C125.505 185.958 125.21 185.878 124.909 185.878C124.609 185.878 124.314 185.958 124.054 186.109L118.876 189.152C118.774 189.211 118.688 189.296 118.629 189.398C118.57 189.501 118.538 189.617 118.538 189.735C118.538 189.854 118.569 189.97 118.628 190.073C118.687 190.175 118.772 190.261 118.874 190.32Z",
    fill: "url(#paint129_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.874 190.258L124.679 193.537C124.898 193.665 125.147 193.732 125.4 193.732C125.654 193.732 125.903 193.665 126.122 193.537L131.372 190.451C131.477 190.389 131.565 190.3 131.625 190.193C131.685 190.086 131.715 189.966 131.714 189.843C131.714 189.843 131.714 189.843 131.714 189.828C131.728 189.963 131.702 190.099 131.641 190.22C131.58 190.34 131.485 190.441 131.368 190.509L126.117 193.596C125.898 193.723 125.65 193.79 125.396 193.79C125.143 193.79 124.894 193.723 124.675 193.596L118.87 190.316C118.758 190.251 118.668 190.156 118.609 190.041C118.551 189.926 118.527 189.796 118.541 189.668C118.541 189.668 118.541 189.668 118.541 189.683C118.54 189.8 118.571 189.914 118.629 190.015C118.688 190.116 118.772 190.2 118.874 190.258Z",
    fill: "url(#paint130_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.055 185.118L113.86 188.398C114.079 188.525 114.328 188.592 114.581 188.592C114.834 188.592 115.083 188.525 115.302 188.398L120.553 185.312C121.026 185.035 121.14 183.359 120.665 183.084L114.937 180.908C114.678 180.756 114.382 180.677 114.082 180.677C113.781 180.677 113.486 180.756 113.226 180.908L107.871 183.023C107.425 183.288 107.607 184.858 108.055 185.118Z",
    fill: "url(#paint131_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.055 184.04L113.857 187.319C114.076 187.447 114.325 187.514 114.579 187.514C114.832 187.514 115.081 187.447 115.3 187.319L120.552 184.233C120.66 184.17 120.75 184.08 120.812 183.971C120.875 183.863 120.908 183.74 120.908 183.615C120.908 183.49 120.875 183.367 120.812 183.258C120.75 183.15 120.66 183.059 120.552 182.996L114.941 179.829C114.682 179.678 114.386 179.598 114.086 179.598C113.785 179.598 113.49 179.678 113.23 179.829L108.053 182.871C107.95 182.931 107.865 183.016 107.806 183.119C107.747 183.221 107.716 183.338 107.716 183.456C107.717 183.574 107.748 183.691 107.807 183.793C107.867 183.895 107.952 183.98 108.055 184.04Z",
    fill: "url(#paint132_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.055 183.981L113.86 187.261C114.079 187.388 114.328 187.456 114.581 187.456C114.834 187.456 115.083 187.388 115.302 187.261L120.553 184.175C120.658 184.113 120.745 184.024 120.805 183.917C120.865 183.811 120.896 183.691 120.895 183.569C120.895 183.569 120.895 183.569 120.895 183.552C120.909 183.687 120.884 183.823 120.822 183.945C120.761 184.066 120.666 184.167 120.548 184.235L115.298 187.321C115.079 187.449 114.83 187.516 114.577 187.516C114.323 187.516 114.075 187.449 113.856 187.321L108.051 184.041C107.939 183.977 107.848 183.882 107.79 183.767C107.732 183.652 107.708 183.522 107.722 183.394C107.722 183.394 107.722 183.394 107.722 183.409C107.721 183.525 107.752 183.639 107.811 183.74C107.869 183.841 107.954 183.924 108.055 183.981Z",
    fill: "url(#paint133_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.697 22.2853L158.723 19.5344H158.736C159.802 18.995 160.985 18.728 162.18 18.7574C163.375 18.7869 164.544 19.1118 165.583 19.7031L288.938 89.2222C291.617 90.7311 293.846 92.9244 295.397 95.5771C296.948 98.2299 297.766 101.247 297.766 104.319V212.11C297.501 220.745 287.661 221.413 287.661 221.413L274.211 194.453L179.817 141.27C177.128 139.755 174.891 137.554 173.334 134.891C171.777 132.228 170.956 129.199 170.956 126.115V55.5611L152.697 22.2853Z",
    fill: "url(#paint134_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.819 22.3226L283.175 91.8208C285.854 93.3298 288.083 95.523 289.634 98.1758C291.185 100.829 292.002 103.846 292.002 106.918V214.708C292.002 215.99 291.666 217.25 291.028 218.362C290.389 219.473 289.47 220.399 288.362 221.045C287.254 221.692 285.996 222.037 284.713 222.047C283.43 222.057 282.167 221.731 281.049 221.101L157.758 151.638C155.069 150.123 152.832 147.921 151.275 145.258C149.718 142.595 148.898 139.567 148.897 136.483V28.6967C148.898 27.4187 149.233 26.1633 149.87 25.0551C150.507 23.9469 151.424 23.0245 152.528 22.3799C153.633 21.7353 154.887 21.3909 156.166 21.3808C157.445 21.3708 158.705 21.6955 159.819 22.3226Z",
    fill: "#314195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.647 217.488C285.384 217.487 286.091 217.193 286.612 216.672C287.134 216.151 287.428 215.445 287.429 214.708V106.918C287.427 104.656 286.824 102.435 285.682 100.481C284.54 98.5283 282.9 96.9128 280.928 95.8002L157.572 26.302C157.164 26.0659 156.702 25.9403 156.23 25.9376C155.498 25.9393 154.796 26.2308 154.278 26.7483C153.761 27.2658 153.469 27.9672 153.468 28.6988V136.483C153.47 138.757 154.076 140.99 155.224 142.953C156.372 144.916 158.021 146.54 160.003 147.659L283.294 217.122C283.704 217.36 284.17 217.487 284.645 217.49L284.647 217.488Z",
    fill: "url(#paint135_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.734 23.064C151.618 23.1098 151.501 23.1472 151.386 23.1972L151.463 23.1348C151.555 23.1098 151.645 23.0848 151.734 23.064Z",
    fill: "url(#paint136_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.58 21.3856C157.546 21.499 158.479 21.8041 159.325 22.2831L282.681 91.7834C285.36 93.2925 287.589 95.4858 289.14 98.1385C290.691 100.791 291.508 103.808 291.508 106.88V214.671C291.514 215.685 291.307 216.689 290.9 217.618C290.492 218.547 289.893 219.379 289.143 220.062C288.864 220.415 288.555 220.742 288.217 221.039C288.467 220.922 288.709 220.792 288.945 220.649C288.543 220.945 288.113 221.199 287.661 221.409C287.999 221.113 288.309 220.786 288.588 220.433C289.339 219.75 289.937 218.917 290.345 217.988C290.753 217.06 290.96 216.056 290.954 215.041V107.247C290.954 104.175 290.137 101.158 288.586 98.5049C287.034 95.8521 284.805 93.6589 282.127 92.1499L158.771 22.6496C157.192 21.749 155.331 21.4768 153.56 21.8874C154.52 21.5086 155.549 21.3376 156.58 21.3856Z",
    fill: "#2D3D92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.982 105.983V126.03L248.398 129.892V109.839L120.002 35.0104L125.586 31.1477L253.982 105.983Z",
    fill: "url(#paint137_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.406 109.837V231.605L125.586 160.026L120.002 35.0084L248.406 109.837Z",
    fill: "url(#paint138_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.404 109.837V238.718L120.008 163.889V35.0084L248.404 109.837Z",
    fill: "url(#paint139_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.4 129.892V238.72L253.984 234.857V126.03L248.4 129.892Z",
    fill: "url(#paint140_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.99 105.981V126.028L248.406 129.89V109.837L253.99 105.981Z",
    fill: "url(#paint141_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.002 35.0104L248.398 109.841V129.892L120.002 55.0613V35.0104Z",
    fill: "url(#paint142_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.99 105.981V126.028L248.406 129.89V109.837L253.99 105.981Z",
    fill: "#063772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.38 101.566V145.92L125.44 108.076V63.7218L190.38 101.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.38 150.78V195.134L125.44 157.304V112.95L190.38 150.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.488 134.026V178.38L194.384 149.181V104.827L244.488 134.026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.488 183.238V227.592L194.384 198.393V154.039L244.488 183.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.195 106.505V72.0115L184.638 103.155V137.643L131.195 106.505Z",
    fill: "white",
    stroke: "#D9DADB",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.191 72.0115L184.634 103.155",
    stroke: "#D9DADB",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.191 76.8322L184.634 107.976",
    stroke: "#D9DADB",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.191 81.6527L184.634 112.796",
    stroke: "#D9DADB",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.191 86.4734L184.634 117.617",
    stroke: "#D9DADB",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.191 91.296L184.634 122.44",
    stroke: "#D9DADB",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.191 96.1167L184.634 127.26",
    stroke: "#D9DADB",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.191 100.937L184.634 132.081",
    stroke: "#D9DADB",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.927 75.3536V109.841",
    stroke: "#D9DADB",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.785 79.4413V113.929",
    stroke: "#D9DADB",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.642 83.5289V118.017",
    stroke: "#D9DADB",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.5 87.6166V122.102",
    stroke: "#D9DADB",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.357 91.7042V126.192",
    stroke: "#D9DADB",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.215 95.7898V130.278",
    stroke: "#D9DADB",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.072 99.8774V134.365",
    stroke: "#D9DADB",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.197 78.2501H134.88L138.251 83.5289L142.388 86.4732L146.244 95.2421L150.65 97.8096L153.879 103.155L155.411 106.437L162.146 104.508L166.106 108.946L171.221 106.864L175.959 107.973L179.273 106.864L182.399 113.925L184.204 115.743",
    stroke: "#F6921E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.165 144.8C134.835 151.071 139.289 156.42 144.975 160.184C153.125 165.255 159.73 162.766 159.73 154.62C159.73 146.474 153.125 135.769 144.975 130.698C143.507 129.759 141.914 129.029 140.244 128.531L144.975 145.439L132.165 144.8Z",
    fill: "url(#paint143_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.226 136.256C130.309 139.202 130.971 142.103 132.175 144.794L144.985 145.433L134.514 128.529C131.862 129.547 130.226 132.21 130.226 136.256Z",
    fill: "url(#paint144_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.522 128.535L144.994 145.439L140.262 128.531C138.399 127.909 136.384 127.911 134.522 128.535Z",
    fill: "url(#paint145_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.475 148.136L185.432 158.756C185.939 159.039 186.347 158.858 186.347 158.354C186.319 158.061 186.221 157.778 186.062 157.53C185.903 157.282 185.687 157.076 185.432 156.927L166.475 146.308C165.969 146.024 165.56 146.206 165.56 146.709C165.588 147.003 165.686 147.285 165.845 147.533C166.004 147.781 166.22 147.988 166.475 148.136Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.475 152.792L185.432 163.412C185.939 163.695 186.347 163.514 186.347 163.01C186.319 162.717 186.221 162.434 186.062 162.186C185.903 161.938 185.687 161.732 185.432 161.583L166.475 150.964C165.969 150.68 165.56 150.862 165.56 151.365C165.588 151.659 165.686 151.941 165.845 152.189C166.004 152.437 166.22 152.644 166.475 152.792Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.475 157.45L185.432 168.07C185.939 168.353 186.347 168.174 186.347 167.668C186.319 167.375 186.222 167.092 186.063 166.844C185.903 166.595 185.687 166.388 185.432 166.24L166.475 155.62C165.969 155.337 165.56 155.516 165.56 156.022C165.588 156.315 165.686 156.598 165.845 156.847C166.004 157.095 166.22 157.302 166.475 157.45Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.475 162.109L185.432 172.728C185.939 173.012 186.347 172.833 186.347 172.327C186.319 172.033 186.221 171.751 186.062 171.503C185.903 171.255 185.687 171.048 185.432 170.9L166.475 160.28C165.969 159.997 165.56 160.176 165.56 160.682C165.588 160.975 165.686 161.258 165.845 161.506C166.004 161.754 166.22 161.96 166.475 162.109Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.475 166.765L185.432 177.384C185.939 177.668 186.347 177.489 186.347 176.983C186.319 176.689 186.221 176.407 186.062 176.159C185.903 175.911 185.687 175.705 185.432 175.556L166.475 164.936C165.969 164.653 165.56 164.832 165.56 165.338C165.588 165.632 165.686 165.914 165.845 166.162C166.004 166.41 166.22 166.616 166.475 166.765Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.475 171.421L185.432 182.041C185.939 182.324 186.347 182.145 186.347 181.639C186.319 181.346 186.221 181.063 186.062 180.815C185.903 180.567 185.687 180.361 185.432 180.212L166.475 169.592C165.969 169.309 165.56 169.488 165.56 169.994C165.588 170.288 165.686 170.57 165.845 170.818C166.004 171.066 166.22 171.273 166.475 171.421Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.14 113.138V116.959C241.14 117.333 241.041 117.7 240.854 118.024C240.667 118.348 240.397 118.617 240.073 118.803C239.749 118.99 239.381 119.088 239.006 119.087C238.632 119.087 238.264 118.988 237.941 118.8L221.208 109.046L159.767 73.2443C159.202 72.9154 158.734 72.4443 158.409 71.8779C158.083 71.3116 157.912 70.6698 157.912 70.0167V65.9561C157.912 65.549 158.019 65.1489 158.223 64.7964C158.427 64.4439 158.721 64.1516 159.074 63.9489C159.428 63.7462 159.828 63.6404 160.236 63.6422C160.643 63.644 161.043 63.7534 161.395 63.9592L221.216 98.8156L238.808 109.067C239.519 109.483 240.108 110.077 240.518 110.792C240.927 111.506 241.141 112.315 241.14 113.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.14 113.138V116.959C241.141 117.333 241.043 117.701 240.855 118.025C240.668 118.349 240.399 118.618 240.074 118.805C239.75 118.992 239.381 119.09 239.007 119.089C238.632 119.088 238.264 118.988 237.941 118.8L221.208 109.046V98.8135L238.8 109.065C239.512 109.48 240.104 110.074 240.514 110.789C240.925 111.504 241.141 112.314 241.14 113.138Z",
    fill: "url(#paint146_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.062 50.8696C131.062 51.9108 130.209 52.2669 129.157 51.6443C128.627 51.3201 128.18 50.8779 127.85 50.3523C127.52 49.8267 127.316 49.2319 127.254 48.6145C127.254 47.5733 128.106 47.2172 129.157 47.8399C129.687 48.1638 130.135 48.6059 130.465 49.1315C130.796 49.6572 131 50.252 131.062 50.8696Z",
    fill: "url(#paint147_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.583 54.1389C136.583 55.1801 135.731 55.5362 134.68 54.9136C134.151 54.5895 133.703 54.1474 133.373 53.6217C133.043 53.0961 132.839 52.5012 132.777 51.8837C132.777 50.8426 133.63 50.4865 134.68 51.1092C135.21 51.4332 135.657 51.8753 135.988 52.401C136.318 52.9266 136.522 53.5215 136.583 54.1389Z",
    fill: "url(#paint148_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.103 57.4082C142.103 58.4494 141.25 58.8055 140.197 58.1829C139.668 57.8587 139.22 57.4165 138.89 56.8909C138.56 56.3653 138.356 55.7705 138.294 55.1531C138.294 54.1119 139.147 53.7558 140.197 54.3784C140.727 54.7024 141.175 55.1445 141.506 55.6701C141.836 56.1957 142.041 56.7906 142.103 57.4082Z",
    fill: "url(#paint149_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.325 126.167L237.166 147.676C237.87 148.092 238.441 147.851 238.441 147.147C238.4 146.734 238.264 146.337 238.042 145.986C237.821 145.636 237.521 145.341 237.166 145.127L200.325 123.616C199.62 123.2 199.047 123.441 199.047 124.147C199.088 124.56 199.225 124.957 199.447 125.308C199.669 125.659 199.969 125.953 200.325 126.167Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.351 140.186L237.505 147.865C238.022 148.167 238.443 147.992 238.443 147.476V146.797C238.413 146.494 238.312 146.202 238.15 145.945C237.987 145.688 237.766 145.472 237.505 145.314L224.351 137.635C223.834 137.333 223.413 137.508 223.413 138.024V138.703C223.443 139.006 223.544 139.298 223.707 139.555C223.87 139.812 224.09 140.028 224.351 140.186Z",
    fill: "url(#paint150_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.325 132.193L237.166 153.702C237.87 154.118 238.441 153.877 238.441 153.171C238.4 152.758 238.264 152.361 238.042 152.01C237.821 151.66 237.521 151.366 237.166 151.151L200.325 129.643C199.62 129.226 199.047 129.468 199.047 130.174C199.088 130.586 199.225 130.984 199.447 131.334C199.669 131.685 199.969 131.979 200.325 132.193Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.872 141.855L237.299 153.777C237.935 154.147 238.45 153.933 238.45 153.298V153.05C238.413 152.678 238.29 152.319 238.09 152.002C237.89 151.686 237.619 151.42 237.299 151.226L216.872 139.304C216.237 138.932 215.72 139.146 215.72 139.781V140.029C215.756 140.402 215.88 140.762 216.08 141.079C216.28 141.396 216.551 141.662 216.872 141.855Z",
    fill: "url(#paint151_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.325 138.222L237.166 159.73C237.87 160.147 238.441 159.905 238.441 159.199C238.4 158.787 238.264 158.39 238.042 158.039C237.821 157.688 237.521 157.394 237.166 157.179L200.325 135.671C199.62 135.254 199.047 135.496 199.047 136.202C199.088 136.615 199.225 137.012 199.447 137.363C199.669 137.713 199.969 138.008 200.325 138.222Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.986 144.446L237.167 159.73C237.872 160.147 238.445 159.905 238.445 159.199C238.404 158.786 238.267 158.389 238.045 158.038C237.823 157.688 237.523 157.394 237.167 157.179L210.986 141.893C210.281 141.476 209.71 141.718 209.71 142.424C209.751 142.837 209.887 143.234 210.109 143.585C210.33 143.936 210.631 144.231 210.986 144.446Z",
    fill: "url(#paint152_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.325 144.248L237.166 165.756C237.87 166.173 238.441 165.931 238.441 165.228C238.4 164.815 238.264 164.418 238.042 164.067C237.821 163.716 237.521 163.422 237.166 163.208L200.325 141.699C199.62 141.283 199.047 141.524 199.047 142.23C199.088 142.642 199.225 143.04 199.447 143.39C199.669 143.74 199.969 144.034 200.325 144.248Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.175 147.665L237.165 165.759C237.87 166.175 238.441 165.933 238.441 165.228C238.4 164.815 238.264 164.418 238.042 164.067C237.821 163.717 237.52 163.422 237.165 163.208L206.175 145.114C205.471 144.698 204.897 144.939 204.897 145.643C204.938 146.056 205.075 146.454 205.297 146.805C205.519 147.156 205.82 147.451 206.175 147.665Z",
    fill: "url(#paint153_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.597 174.963L238.829 188.527C239.273 188.787 239.633 188.637 239.633 188.194C239.607 187.934 239.521 187.683 239.382 187.461C239.242 187.24 239.053 187.055 238.829 186.919L215.597 173.355C215.15 173.095 214.792 173.244 214.792 173.69C214.818 173.95 214.904 174.201 215.044 174.421C215.183 174.642 215.373 174.828 215.597 174.963Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.248 171.874L218.542 176.718C218.869 176.907 219.134 176.799 219.134 176.472V176.045C219.115 175.854 219.051 175.67 218.949 175.508C218.846 175.346 218.707 175.209 218.542 175.11L210.248 170.267C209.921 170.077 209.656 170.186 209.656 170.512V170.94C209.676 171.131 209.739 171.314 209.842 171.477C209.944 171.639 210.084 171.775 210.248 171.874Z",
    fill: "url(#paint154_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.597 178.763L238.829 192.325C239.273 192.585 239.633 192.435 239.633 191.99C239.607 191.73 239.521 191.479 239.382 191.258C239.242 191.037 239.053 190.851 238.829 190.716L215.597 177.151C215.15 176.891 214.792 177.041 214.792 177.486C214.817 177.747 214.903 177.998 215.043 178.22C215.183 178.441 215.372 178.627 215.597 178.763Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.531 172.92L218.406 180.437C218.808 180.67 219.134 180.535 219.134 180.135V179.979C219.11 179.744 219.032 179.518 218.906 179.319C218.78 179.119 218.608 178.952 218.406 178.83L205.531 171.312C205.129 171.079 204.804 171.214 204.804 171.614V171.771C204.827 172.005 204.905 172.232 205.031 172.431C205.158 172.631 205.329 172.798 205.531 172.92Z",
    fill: "url(#paint155_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.598 182.563L238.831 196.127C239.275 196.388 239.635 196.238 239.635 195.794C239.609 195.534 239.523 195.284 239.383 195.062C239.244 194.841 239.054 194.655 238.831 194.52L215.598 180.958C215.152 180.697 214.794 180.847 214.794 181.291C214.82 181.551 214.906 181.801 215.046 182.022C215.185 182.243 215.375 182.428 215.598 182.563Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.821 174.554L218.331 184.194C218.777 184.454 219.136 184.304 219.136 183.858C219.11 183.598 219.024 183.347 218.884 183.126C218.745 182.905 218.555 182.719 218.331 182.584L201.821 172.945C201.377 172.684 201.017 172.834 201.017 173.28C201.042 173.54 201.129 173.791 201.268 174.012C201.408 174.233 201.597 174.419 201.821 174.554Z",
    fill: "url(#paint156_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.597 186.366L238.829 199.93C239.273 200.19 239.633 200.04 239.633 199.597C239.607 199.336 239.521 199.086 239.382 198.865C239.242 198.644 239.053 198.458 238.829 198.322L215.597 184.76C215.15 184.5 214.792 184.65 214.792 185.095C214.818 185.355 214.904 185.605 215.044 185.825C215.184 186.046 215.373 186.231 215.597 186.366Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.788 176.585L218.331 187.994C218.775 188.254 219.136 188.104 219.136 187.659C219.115 187.416 219.041 187.182 218.919 186.972C218.797 186.761 218.63 186.581 218.429 186.443L198.886 175.033C198.345 174.717 197.982 174.867 197.982 175.31C198.008 175.571 198.095 175.822 198.235 176.043C198.375 176.264 198.564 176.45 198.788 176.585Z",
    fill: "url(#paint157_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.597 190.641L238.829 204.203C239.273 204.463 239.633 204.313 239.633 203.868C239.607 203.607 239.521 203.357 239.382 203.136C239.242 202.914 239.053 202.729 238.829 202.593L215.597 189.029C215.15 188.769 214.792 188.919 214.792 189.364C214.817 189.625 214.903 189.876 215.043 190.098C215.183 190.319 215.372 190.505 215.597 190.641Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.248 187.553L218.542 192.396C218.869 192.588 219.134 192.477 219.134 192.15V191.724C219.115 191.533 219.051 191.348 218.949 191.186C218.846 191.024 218.707 190.888 218.542 190.788L210.248 185.945C209.921 185.754 209.656 185.864 209.656 186.191V186.618C209.676 186.809 209.739 186.993 209.842 187.155C209.944 187.317 210.084 187.453 210.248 187.553Z",
    fill: "url(#paint158_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.598 194.441L238.831 208.005C239.275 208.265 239.635 208.116 239.635 207.67C239.609 207.41 239.523 207.159 239.384 206.938C239.244 206.717 239.055 206.531 238.831 206.396L215.598 192.831C215.152 192.571 214.794 192.721 214.794 193.166C214.82 193.427 214.906 193.678 215.045 193.899C215.185 194.12 215.374 194.306 215.598 194.441Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.533 188.598L218.408 196.115C218.81 196.349 219.136 196.215 219.136 195.813V195.657C219.112 195.422 219.034 195.196 218.908 194.996C218.782 194.797 218.61 194.629 218.408 194.508L205.533 186.99C205.131 186.757 204.806 186.892 204.806 187.292V187.449C204.829 187.684 204.907 187.91 205.033 188.109C205.16 188.309 205.331 188.476 205.533 188.598Z",
    fill: "url(#paint159_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.598 198.241L238.831 211.803C239.275 212.064 239.635 211.914 239.635 211.47C239.609 211.21 239.523 210.959 239.383 210.738C239.244 210.517 239.054 210.331 238.831 210.196L215.598 196.633C215.152 196.373 214.794 196.523 214.794 196.969C214.82 197.229 214.906 197.479 215.046 197.7C215.185 197.921 215.375 198.106 215.598 198.241Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.821 190.232L218.331 199.871C218.777 200.132 219.136 199.982 219.136 199.536C219.11 199.276 219.024 199.025 218.884 198.804C218.745 198.583 218.555 198.397 218.331 198.262L201.821 188.623C201.377 188.362 201.017 188.512 201.017 188.958C201.042 189.218 201.129 189.469 201.268 189.69C201.408 189.911 201.597 190.097 201.821 190.232Z",
    fill: "url(#paint160_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.597 202.042L238.829 215.606C239.273 215.866 239.633 215.716 239.633 215.271C239.607 215.01 239.521 214.76 239.382 214.538C239.242 214.317 239.053 214.132 238.829 213.996L215.597 200.432C215.15 200.171 214.792 200.324 214.792 200.767C214.818 201.027 214.904 201.278 215.043 201.499C215.183 201.721 215.372 201.906 215.597 202.042Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.788 192.261L218.331 203.67C218.775 203.93 219.136 203.78 219.136 203.335C219.11 203.074 219.024 202.823 218.884 202.602C218.745 202.381 218.555 202.195 218.331 202.06L198.788 190.651C198.344 190.391 197.984 190.541 197.984 190.986C198.01 191.246 198.096 191.497 198.235 191.718C198.375 191.94 198.564 192.125 198.788 192.261Z",
    fill: "url(#paint161_linear_6_379)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.037,
    d: "M167.31 296.294C167.633 280.245 140.098 266.676 105.808 265.987C71.5191 265.298 43.4602 277.75 43.1372 293.799C42.8141 309.849 70.3492 323.417 104.639 324.106C138.928 324.795 166.987 312.343 167.31 296.294Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.074,
    d: "M166.222 296.269C166.54 280.5 139.487 267.169 105.798 266.492C72.1097 265.815 44.5425 278.049 44.2251 293.818C43.9077 309.587 70.9604 322.918 104.649 323.595C138.337 324.272 165.905 312.037 166.222 296.269Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.111,
    d: "M165.137 296.248C165.449 280.761 138.878 267.668 105.791 267.003C72.7028 266.338 45.6271 278.354 45.3154 293.841C45.0037 309.328 71.5739 322.421 104.662 323.086C137.749 323.751 164.825 311.735 165.137 296.248Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.148,
    d: "M164.045 296.227C164.351 281.022 138.265 268.167 105.779 267.514C73.2929 266.861 46.7098 278.659 46.4038 293.864C46.0977 309.069 72.1846 321.924 104.67 322.577C137.156 323.229 163.739 311.432 164.045 296.227Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.185,
    d: "M162.958 296.204C163.258 281.279 137.654 268.661 105.769 268.021C73.8836 267.38 47.7921 278.96 47.4917 293.884C47.1913 308.809 72.7957 321.427 104.681 322.068C136.566 322.708 162.657 311.129 162.958 296.204Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.222,
    d: "M161.87 296.183C162.165 281.54 137.043 269.16 105.759 268.532C74.4746 267.903 48.8748 279.264 48.5801 293.907C48.2853 308.55 73.4073 320.93 104.692 321.558C135.976 322.187 161.576 310.826 161.87 296.183Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.259,
    d: "M160.779 296.16C161.068 281.799 136.43 269.657 105.747 269.041C75.0648 268.424 49.9575 279.567 49.6684 293.928C49.3794 308.289 74.018 320.431 104.7 321.047C135.383 321.664 160.49 310.521 160.779 296.16Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.296,
    d: "M159.691 296.139C159.975 282.06 135.819 270.156 105.737 269.552C75.6554 268.947 51.0397 279.871 50.7563 293.951C50.4729 308.03 74.6291 319.934 104.711 320.538C134.792 321.142 159.408 310.219 159.691 296.139Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "M158.602 296.116C158.88 282.317 135.207 270.651 105.727 270.059C76.2475 269.466 52.1244 280.172 51.8467 293.971C51.5689 307.77 75.2417 319.437 104.721 320.029C134.201 320.621 158.324 309.915 158.602 296.116Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M157.515 296.095C157.787 282.578 134.596 271.15 105.717 270.57C76.8386 269.989 53.2071 280.477 52.935 293.994C52.6629 307.511 75.8533 318.94 104.732 319.52C133.611 320.1 157.243 309.612 157.515 296.095Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.407,
    d: "M156.427 296.074C156.693 282.839 133.985 271.649 105.707 271.081C77.4292 270.512 54.2893 280.781 54.0229 294.017C53.7565 307.252 76.4644 318.442 104.743 319.011C133.021 319.579 156.161 309.31 156.427 296.074Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "M155.336 296.053C155.596 283.099 133.372 272.148 105.695 271.592C78.0193 271.036 55.372 281.086 55.1113 294.04C54.8505 306.994 77.0751 317.945 104.751 318.501C132.427 319.057 155.075 309.007 155.336 296.053Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.481,
    d: "M154.248 296.028C154.503 283.355 132.761 272.64 105.686 272.096C78.6105 271.552 56.4548 281.385 56.1997 294.058C55.9446 306.732 77.6867 317.446 104.762 317.99C131.837 318.534 153.993 308.701 154.248 296.028Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.518,
    d: "M153.163 296.007C153.412 283.616 132.153 273.139 105.678 272.607C79.2035 272.075 57.5394 281.69 57.29 294.081C57.0406 306.473 78.3003 316.949 104.775 317.481C131.249 318.013 152.914 308.399 153.163 296.007Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556,
    d: "M152.071 295.986C152.315 283.876 131.538 273.638 105.666 273.118C79.7932 272.599 58.6216 281.994 58.3779 294.104C58.1341 306.214 78.9105 316.452 104.783 316.972C130.656 317.492 151.827 308.096 152.071 295.986Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.593,
    d: "M150.984 295.965C151.222 284.137 130.928 274.137 105.656 273.629C80.3842 273.122 59.7043 282.299 59.4662 294.127C59.2282 305.955 79.5221 315.955 104.794 316.463C130.066 316.971 150.746 307.794 150.984 295.965Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M149.896 295.942C150.129 284.395 130.317 274.632 105.646 274.136C80.9749 273.641 60.7866 282.6 60.5542 294.148C60.3217 305.695 80.1332 315.458 104.804 315.954C129.475 316.449 149.664 307.49 149.896 295.942Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "M148.805 295.919C149.031 284.653 129.703 275.129 105.634 274.645C81.565 274.162 61.8693 282.902 61.6425 294.168C61.4158 305.434 80.7439 314.959 104.813 315.442C128.882 315.926 148.578 307.185 148.805 295.919Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.704,
    d: "M147.719 295.898C147.941 284.914 129.095 275.628 105.626 275.156C82.1581 274.685 62.9539 283.207 62.7328 294.191C62.5118 305.175 81.3574 314.462 104.826 314.933C128.294 315.405 147.498 306.883 147.719 295.898Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.741,
    d: "M146.628 295.877C146.843 285.175 128.481 276.126 105.615 275.667C82.7482 275.208 64.0366 283.511 63.8212 294.214C63.6058 304.916 81.9681 313.965 104.835 314.424C127.701 314.884 146.413 306.58 146.628 295.877Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.778,
    d: "M145.54 295.854C145.75 285.432 127.87 276.621 105.605 276.174C83.3389 275.727 65.1189 283.813 64.9091 294.235C64.6994 304.656 82.5792 313.468 104.845 313.915C127.111 314.362 145.331 306.276 145.54 295.854Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.815,
    d: "M144.453 295.834C144.657 285.693 127.26 277.12 105.595 276.685C83.9299 276.25 66.2016 284.117 65.9975 294.257C65.7934 304.398 83.1908 312.971 104.856 313.406C126.521 313.841 144.249 305.974 144.453 295.834Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.852,
    d: "M143.361 295.81C143.56 285.952 126.646 277.617 105.583 277.194C84.5196 276.771 67.2838 284.42 67.0854 294.278C66.8869 304.137 83.801 312.472 104.864 312.895C125.927 313.318 143.163 305.669 143.361 295.81Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.889,
    d: "M142.274 295.787C142.467 286.21 126.035 278.112 105.573 277.701C85.1107 277.29 68.3666 284.721 68.1738 294.299C67.981 303.877 84.4126 311.974 104.875 312.386C125.337 312.797 142.081 305.365 142.274 295.787Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.926,
    d: "M141.189 295.767C141.376 286.47 125.427 278.611 105.565 278.212C85.7038 277.813 69.4512 285.025 69.2641 294.322C69.077 303.618 85.0262 311.478 104.888 311.877C124.749 312.276 141.002 305.063 141.189 295.767Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.963,
    d: "M140.097 295.746C140.279 286.731 124.813 279.11 105.553 278.723C86.2939 278.336 70.5339 285.33 70.3525 294.344C70.171 303.359 85.6368 310.98 104.896 311.367C124.156 311.754 139.916 304.76 140.097 295.746Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.009 295.725C139.185 286.992 124.202 279.609 105.543 279.234C86.8845 278.859 71.6161 285.634 71.4403 294.367C71.2646 303.1 86.2479 310.483 104.907 310.858C123.565 311.233 138.834 304.458 139.009 295.725Z",
    fill: "#141414"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.7368 110.916V220.887L163.194 279.388V170.234L58.7368 110.916Z",
    fill: "url(#paint162_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.442 147.892L96.9868 150.664L104.491 170.238L109.945 167.466L102.442 147.892Z",
    fill: "url(#paint163_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7371 110.916V123.054L47.8984 116.894L58.7371 110.916Z",
    fill: "url(#paint164_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.194 170.232L58.7368 110.914L47.8983 116.892L42.062 113.575L58.32 104.509L168.944 166.563L163.194 170.232Z",
    fill: "url(#paint165_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.498 274.517L163.192 279.386L154.498 283.627V274.517Z",
    fill: "#2C89B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1235 114.11V224.081L156.58 282.582V173.42L52.1235 114.11Z",
    fill: "url(#paint166_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.333 279.707V169.759L156.579 173.422V282.576L162.333 279.707Z",
    fill: "url(#paint167_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.58 173.426L52.1235 114.108L57.4366 110.916L162.333 169.761L156.58 173.426Z",
    fill: "url(#paint168_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0646 113.577L102.44 147.892L109.943 167.466L154.498 193.731V289.435L42.0646 225.091L36.6099 116.34L42.0646 113.577Z",
    fill: "#3BAEE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6098 116.349L96.987 150.664L104.491 170.238L149.035 196.511V292.215L36.6016 227.871L36.6098 116.349Z",
    fill: "#61BBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.043 292.211L168.947 281.783V166.571L163.194 170.234V279.388L152.885 284.417L149.043 292.211Z",
    fill: "#3BAEE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.498 193.733L149.043 196.507V292.211L154.498 289.439V193.733Z",
    fill: "url(#paint169_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3636 183.915C53.2052 183.844 53.051 183.788 52.8967 183.727C52.6737 183.642 52.4528 183.565 52.2339 183.498C52.0922 183.457 51.9525 183.415 51.817 183.382C51.6816 183.348 51.5607 183.323 51.4314 183.3C51.2626 183.269 51.0958 183.242 50.9332 183.223C50.8374 183.213 50.7436 183.2 50.6498 183.194C50.4442 183.18 50.2426 183.176 50.0453 183.182C49.9994 183.182 49.9536 183.182 49.9077 183.182C49.674 183.195 49.4414 183.224 49.2116 183.269C49.1553 183.28 49.1011 183.294 49.0448 183.307C48.8698 183.347 48.6972 183.397 48.5279 183.457C48.4758 183.475 48.4217 183.492 48.3695 183.513C48.1539 183.595 47.9448 183.693 47.7441 183.806L57.6303 178.067L57.6823 178.038C57.8353 177.952 57.9934 177.875 58.1556 177.807C58.1847 177.795 58.218 177.786 58.2472 177.774C58.2763 177.761 58.3535 177.736 58.4077 177.718C58.4619 177.699 58.5682 177.655 58.6516 177.63C58.735 177.605 58.8329 177.588 58.9226 177.568L59.0893 177.53L59.1789 177.509C59.3672 177.477 59.5572 177.454 59.748 177.443H59.921C60.069 177.443 60.217 177.432 60.3712 177.443C60.4212 177.443 60.4754 177.455 60.5254 177.457C60.6192 177.457 60.715 177.476 60.8088 177.487C60.9026 177.497 60.9819 177.499 61.0715 177.511C61.1612 177.524 61.2278 177.547 61.307 177.562C61.4342 177.584 61.5634 177.611 61.6926 177.643C61.7635 177.659 61.8303 177.668 61.9011 177.686C61.972 177.705 62.0428 177.739 62.1095 177.759C62.3179 177.824 62.5493 177.901 62.7723 177.988C62.8515 178.02 62.9265 178.036 63.0078 178.07C63.0891 178.103 63.162 178.142 63.2412 178.176L63.4644 178.278C63.7499 178.411 64.0355 178.557 64.3273 178.726L109.193 204.603C109.495 204.778 109.795 204.969 110.089 205.173C110.185 205.238 110.279 205.311 110.372 205.382C110.581 205.525 110.769 205.671 110.965 205.827C111.073 205.915 111.173 206.004 111.288 206.094C111.467 206.244 111.644 206.398 111.819 206.558C111.926 206.654 112.032 206.753 112.138 206.854C112.203 206.916 112.271 206.975 112.336 207.039C112.401 207.104 112.469 207.185 112.544 207.247C112.757 207.464 112.965 207.686 113.17 207.914C113.234 207.987 113.305 208.053 113.378 208.122C113.451 208.191 113.482 208.251 113.536 208.316C113.662 208.461 113.783 208.611 113.903 208.761C113.983 208.859 114.066 208.953 114.141 209.051C114.216 209.149 114.264 209.219 114.327 209.303L114.587 209.657C114.645 209.74 114.708 209.819 114.766 209.902C114.864 210.042 114.958 210.188 115.054 210.331C115.114 210.421 115.175 210.51 115.235 210.602L115.312 210.715C115.479 210.976 115.641 211.241 115.798 211.51L115.827 211.564C115.858 211.618 115.89 211.674 115.919 211.731C116.027 211.92 116.127 212.11 116.238 212.303C116.286 212.393 116.327 212.484 116.375 212.574C116.423 212.664 116.473 212.763 116.519 212.857C116.565 212.951 116.605 213.02 116.644 213.103C116.751 213.322 116.853 213.542 116.949 213.765L117.003 213.886L117.017 213.919C117.138 214.197 117.254 214.478 117.363 214.763C117.382 214.815 117.399 214.865 117.418 214.917C117.457 215.021 117.493 215.125 117.53 215.227C117.58 215.369 117.634 215.508 117.682 215.643C117.718 215.752 117.749 215.862 117.782 215.972C117.816 216.083 117.864 216.233 117.901 216.362C117.924 216.441 117.953 216.522 117.974 216.601C118.014 216.745 118.043 216.887 118.08 217.03C118.118 217.174 118.162 217.351 118.199 217.511C118.212 217.567 118.228 217.624 118.241 217.68C118.266 217.797 118.278 217.911 118.299 218.026C118.347 218.276 118.393 218.525 118.429 218.773C118.429 218.844 118.456 218.913 118.464 218.981C118.485 219.138 118.495 219.294 118.51 219.448C118.52 219.558 118.535 219.671 118.543 219.781C118.57 220.131 118.587 220.476 118.585 220.822L118.431 298.725C118.548 299.884 118.356 301.054 117.873 302.115C117.391 303.176 116.635 304.09 115.683 304.763L105.797 310.502C106.749 309.829 107.505 308.915 107.988 307.854C108.47 306.793 108.663 305.623 108.545 304.464L108.699 226.561C108.699 226.22 108.684 225.872 108.657 225.52C108.657 225.41 108.636 225.297 108.624 225.187C108.601 224.963 108.574 224.738 108.542 224.512C108.507 224.264 108.461 224.012 108.413 223.765C108.38 223.594 108.351 223.423 108.313 223.25C108.276 223.077 108.236 222.93 108.194 222.769C108.138 222.546 108.082 222.323 108.015 222.099C107.978 221.969 107.936 221.838 107.896 221.709C107.817 221.459 107.733 221.209 107.644 220.96C107.607 220.855 107.571 220.751 107.532 220.649C107.402 220.304 107.265 219.96 107.115 219.608L107.058 219.487C106.919 219.182 106.777 218.879 106.631 218.58L106.487 218.294C106.341 218.016 106.189 217.736 106.029 217.451C105.997 217.397 105.968 217.34 105.937 217.286C105.747 216.959 105.549 216.639 105.345 216.322C105.287 216.231 105.224 216.143 105.164 216.054C105.011 215.826 104.854 215.601 104.695 215.379C104.61 215.26 104.523 215.142 104.434 215.027C104.295 214.844 104.153 214.663 104.017 214.486C103.882 214.309 103.776 214.186 103.65 214.04C103.525 213.894 103.413 213.769 103.292 213.634C103.086 213.406 102.878 213.183 102.667 212.965C102.535 212.83 102.402 212.695 102.266 212.566C102.131 212.437 102.058 212.357 101.95 212.272C101.775 212.112 101.597 211.958 101.416 211.808C101.31 211.718 101.208 211.629 101.095 211.541C100.901 211.387 100.703 211.239 100.503 211.096C100.409 211.027 100.316 210.954 100.22 210.887C99.9237 210.679 99.6256 210.494 99.3234 210.319L54.4578 184.44C54.166 184.271 53.8784 184.127 53.5949 183.992L53.3636 183.915Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4494 184.462C49.249 181.464 45.0219 183.871 45.0053 189.833L44.8511 267.735C45.0213 270.99 45.9598 274.158 47.59 276.981C49.2201 279.804 51.4957 282.201 54.2306 283.977L99.0961 309.855C104.29 312.851 108.519 310.444 108.536 304.474L108.69 226.571C108.518 223.319 107.579 220.154 105.948 217.334C104.318 214.514 102.044 212.119 99.3108 210.344L54.4494 184.462Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.911 304.822L108.065 226.919C107.893 223.667 106.953 220.502 105.323 217.682C103.693 214.861 101.418 212.466 98.6853 210.691L53.8197 184.812C52.9151 184.177 51.8708 183.768 50.7749 183.62C49.679 183.473 48.5636 183.591 47.5229 183.965C48.6055 183.382 49.832 183.119 51.0586 183.207C52.2852 183.295 53.4613 183.731 54.4492 184.462L99.3148 210.342C102.048 212.116 104.322 214.511 105.952 217.332C107.582 220.152 108.522 223.317 108.694 226.569L108.54 304.472C108.683 305.704 108.461 306.951 107.901 308.057C107.341 309.164 106.468 310.083 105.391 310.698C106.266 310.004 106.955 309.104 107.394 308.078C107.834 307.052 108.012 305.933 107.911 304.822Z",
    fill: "url(#paint170_linear_6_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8672 227.863L79.322 215.185L95.3715 248.172L84.9706 242.05V286.172L69.3796 278.884V232.879L60.8672 227.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.499 170.234L96.9953 150.66L36.6182 116.345V117.226L96.17 151.072L103.674 170.646L148.218 196.919V291.74L149.052 292.211V196.507L104.499 170.234Z",
    fill: "url(#paint171_linear_6_379)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_379",
    x1: 674.237,
    y1: 223.322,
    x2: 816.824,
    y2: 193.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_379",
    x1: 674.237,
    y1: 222.856,
    x2: 816.824,
    y2: 193.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_379",
    x1: 771.052,
    y1: 248.259,
    x2: 759.244,
    y2: 178.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_379",
    x1: 854.934,
    y1: 226.182,
    x2: 863.838,
    y2: 224.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_379",
    x1: 671.565,
    y1: 222.082,
    x2: 671.479,
    y2: 229.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_379",
    x1: 844.006,
    y1: 219.906,
    x2: 852.909,
    y2: 218.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_379",
    x1: 682.447,
    y1: 215.813,
    x2: 682.361,
    y2: 223.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6_379",
    x1: 687.945,
    y1: 213.632,
    x2: 696.849,
    y2: 211.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6_379",
    x1: 694.207,
    y1: 214.888,
    x2: 693.288,
    y2: 209.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6_379",
    x1: 693.264,
    y1: 209.531,
    x2: 693.178,
    y2: 216.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6_379",
    x1: 698.826,
    y1: 207.353,
    x2: 707.731,
    y2: 205.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6_379",
    x1: 705.106,
    y1: 208.614,
    x2: 704.193,
    y2: 203.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6_379",
    x1: 704.029,
    y1: 203.258,
    x2: 703.943,
    y2: 210.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6_379",
    x1: 709.622,
    y1: 201.079,
    x2: 718.527,
    y2: 199.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6_379",
    x1: 715.839,
    y1: 202.338,
    x2: 714.921,
    y2: 196.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6_379",
    x1: 714.928,
    y1: 196.985,
    x2: 714.842,
    y2: 204.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6_379",
    x1: 720.412,
    y1: 194.803,
    x2: 729.316,
    y2: 192.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6_379",
    x1: 726.725,
    y1: 196.059,
    x2: 725.812,
    y2: 190.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6_379",
    x1: 725.742,
    y1: 190.706,
    x2: 725.656,
    y2: 198.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6_379",
    x1: 731.257,
    y1: 188.527,
    x2: 740.162,
    y2: 186.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6_379",
    x1: 737.489,
    y1: 189.784,
    x2: 736.571,
    y2: 184.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6_379",
    x1: 736.485,
    y1: 184.428,
    x2: 736.399,
    y2: 191.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6_379",
    x1: 742.172,
    y1: 182.25,
    x2: 751.078,
    y2: 180.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6_379",
    x1: 748.238,
    y1: 183.509,
    x2: 747.32,
    y2: 178.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6_379",
    x1: 747.313,
    y1: 178.149,
    x2: 747.227,
    y2: 185.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6_379",
    x1: 752.85,
    y1: 175.974,
    x2: 761.754,
    y2: 174.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_6_379",
    x1: 759.31,
    y1: 177.23,
    x2: 758.392,
    y2: 171.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_6_379",
    x1: 758.139,
    y1: 171.877,
    x2: 758.053,
    y2: 179.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_6_379",
    x1: 763.734,
    y1: 169.698,
    x2: 772.639,
    y2: 167.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_6_379",
    x1: 770.13,
    y1: 170.957,
    x2: 769.212,
    y2: 165.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_6_379",
    x1: 768.959,
    y1: 165.601,
    x2: 768.873,
    y2: 172.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_6_379",
    x1: 774.424,
    y1: 163.424,
    x2: 783.328,
    y2: 161.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_6_379",
    x1: 780.872,
    y1: 164.683,
    x2: 779.953,
    y2: 159.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_6_379",
    x1: 779.88,
    y1: 159.32,
    x2: 779.794,
    y2: 166.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_6_379",
    x1: 845.718,
    y1: 231.573,
    x2: 854.623,
    y2: 229.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_6_379",
    x1: 680.838,
    y1: 227.482,
    x2: 680.752,
    y2: 234.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_6_379",
    x1: 686.418,
    y1: 225.299,
    x2: 695.323,
    y2: 223.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_6_379",
    x1: 692.787,
    y1: 226.555,
    x2: 691.874,
    y2: 221.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_6_379",
    x1: 691.685,
    y1: 221.195,
    x2: 691.598,
    y2: 228.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_6_379",
    x1: 697.173,
    y1: 219.02,
    x2: 706.076,
    y2: 217.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_6_379",
    x1: 703.453,
    y1: 220.279,
    x2: 702.54,
    y2: 214.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_6_379",
    x1: 702.513,
    y1: 214.928,
    x2: 702.427,
    y2: 222.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_6_379",
    x1: 708.065,
    y1: 212.746,
    x2: 716.984,
    y2: 210.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_6_379",
    x1: 714.313,
    y1: 214.005,
    x2: 713.395,
    y2: 208.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_6_379",
    x1: 713.322,
    y1: 208.646,
    x2: 713.235,
    y2: 216.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_6_379",
    x1: 718.945,
    y1: 206.47,
    x2: 727.851,
    y2: 204.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_6_379",
    x1: 725.192,
    y1: 207.725,
    x2: 724.274,
    y2: 202.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_6_379",
    x1: 724.211,
    y1: 202.369,
    x2: 724.125,
    y2: 209.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_6_379",
    x1: 729.671,
    y1: 200.194,
    x2: 738.575,
    y2: 198.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_6_379",
    x1: 735.972,
    y1: 201.451,
    x2: 735.054,
    y2: 196.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_6_379",
    x1: 734.972,
    y1: 196.099,
    x2: 734.885,
    y2: 203.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_6_379",
    x1: 740.562,
    y1: 193.918,
    x2: 749.467,
    y2: 192.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_6_379",
    x1: 746.836,
    y1: 195.175,
    x2: 745.923,
    y2: 189.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_6_379",
    x1: 745.693,
    y1: 189.818,
    x2: 745.606,
    y2: 197.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_6_379",
    x1: 751.24,
    y1: 187.642,
    x2: 760.157,
    y2: 185.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_6_379",
    x1: 757.738,
    y1: 188.9,
    x2: 756.82,
    y2: 183.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_6_379",
    x1: 756.604,
    y1: 183.547,
    x2: 756.517,
    y2: 190.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_6_379",
    x1: 762.115,
    y1: 181.365,
    x2: 771.019,
    y2: 179.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_6_379",
    x1: 768.434,
    y1: 182.624,
    x2: 767.521,
    y2: 177.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_6_379",
    x1: 767.431,
    y1: 177.273,
    x2: 767.345,
    y2: 184.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_6_379",
    x1: 772.99,
    y1: 175.091,
    x2: 781.894,
    y2: 173.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_6_379",
    x1: 779.247,
    y1: 176.348,
    x2: 778.329,
    y2: 171.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_6_379",
    x1: 778.241,
    y1: 170.997,
    x2: 778.156,
    y2: 178.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_6_379",
    x1: 784.066,
    y1: 168.815,
    x2: 792.974,
    y2: 166.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_6_379",
    x1: 790.023,
    y1: 170.072,
    x2: 789.111,
    y2: 164.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_6_379",
    x1: 789.07,
    y1: 164.718,
    x2: 788.983,
    y2: 172.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_6_379",
    x1: 836.415,
    y1: 236.964,
    x2: 845.321,
    y2: 235.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_6_379",
    x1: 690.201,
    y1: 232.868,
    x2: 690.115,
    y2: 240.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_6_379",
    x1: 825.605,
    y1: 230.69,
    x2: 834.51,
    y2: 228.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_6_379",
    x1: 701.031,
    y1: 226.593,
    x2: 700.944,
    y2: 233.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_6_379",
    x1: 814.728,
    y1: 224.416,
    x2: 823.632,
    y2: 222.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_6_379",
    x1: 711.77,
    y1: 220.319,
    x2: 711.683,
    y2: 227.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_6_379",
    x1: 803.856,
    y1: 218.14,
    x2: 812.76,
    y2: 216.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_6_379",
    x1: 722.681,
    y1: 214.041,
    x2: 722.595,
    y2: 221.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_6_379",
    x1: 793.076,
    y1: 211.863,
    x2: 801.98,
    y2: 210.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_6_379",
    x1: 733.419,
    y1: 207.769,
    x2: 733.332,
    y2: 215.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_6_379",
    x1: 782.227,
    y1: 205.585,
    x2: 791.131,
    y2: 203.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_6_379",
    x1: 744.259,
    y1: 201.49,
    x2: 744.172,
    y2: 208.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_6_379",
    x1: 771.562,
    y1: 199.311,
    x2: 780.468,
    y2: 197.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_6_379",
    x1: 755.093,
    y1: 195.216,
    x2: 755.006,
    y2: 202.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_6_379",
    x1: 760.626,
    y1: 193.035,
    x2: 769.531,
    y2: 191.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_6_379",
    x1: 765.979,
    y1: 188.938,
    x2: 765.892,
    y2: 196.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_6_379",
    x1: 771.468,
    y1: 186.763,
    x2: 780.373,
    y2: 184.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_6_379",
    x1: 777.753,
    y1: 188.016,
    x2: 776.835,
    y2: 182.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_6_379",
    x1: 776.714,
    y1: 182.662,
    x2: 776.627,
    y2: 190.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_6_379",
    x1: 782.329,
    y1: 180.483,
    x2: 791.234,
    y2: 178.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_6_379",
    x1: 788.731,
    y1: 181.739,
    x2: 787.813,
    y2: 176.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_6_379",
    x1: 787.566,
    y1: 176.388,
    x2: 787.48,
    y2: 183.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_6_379",
    x1: 794.441,
    y1: 177.147,
    x2: 809.227,
    y2: 174.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_6_379",
    x1: 805.667,
    y1: 181.484,
    x2: 803.682,
    y2: 169.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_6_379",
    x1: 803.161,
    y1: 171.526,
    x2: 802.927,
    y2: 182.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_6_379",
    x1: 827.051,
    y1: 242.357,
    x2: 835.955,
    y2: 240.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_6_379",
    x1: 699.435,
    y1: 238.262,
    x2: 699.349,
    y2: 245.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_6_379",
    x1: 816.331,
    y1: 236.081,
    x2: 825.237,
    y2: 234.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_6_379",
    x1: 710.247,
    y1: 231.986,
    x2: 710.161,
    y2: 239.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_6_379",
    x1: 805.48,
    y1: 229.807,
    x2: 814.385,
    y2: 227.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_6_379",
    x1: 721.072,
    y1: 225.71,
    x2: 720.985,
    y2: 233.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_6_379",
    x1: 794.62,
    y1: 223.529,
    x2: 803.525,
    y2: 221.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_6_379",
    x1: 731.983,
    y1: 219.434,
    x2: 731.897,
    y2: 226.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_6_379",
    x1: 783.862,
    y1: 217.255,
    x2: 792.768,
    y2: 215.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_6_379",
    x1: 742.723,
    y1: 213.158,
    x2: 742.637,
    y2: 220.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_6_379",
    x1: 772.978,
    y1: 210.976,
    x2: 781.883,
    y2: 209.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_6_379",
    x1: 753.624,
    y1: 206.89,
    x2: 753.537,
    y2: 214.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_6_379",
    x1: 762.07,
    y1: 204.702,
    x2: 770.973,
    y2: 202.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_6_379",
    x1: 764.347,
    y1: 200.606,
    x2: 764.26,
    y2: 207.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_6_379",
    x1: 769.973,
    y1: 198.426,
    x2: 778.878,
    y2: 196.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_6_379",
    x1: 776.202,
    y1: 199.685,
    x2: 775.284,
    y2: 194.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_6_379",
    x1: 775.171,
    y1: 194.331,
    x2: 775.084,
    y2: 201.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_6_379",
    x1: 780.724,
    y1: 192.15,
    x2: 789.628,
    y2: 190.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_6_379",
    x1: 787.016,
    y1: 193.407,
    x2: 786.098,
    y2: 188.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_6_379",
    x1: 786.018,
    y1: 188.053,
    x2: 785.931,
    y2: 195.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_6_379",
    x1: 791.347,
    y1: 185.874,
    x2: 800.249,
    y2: 184.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_6_379",
    x1: 797.916,
    y1: 187.13,
    x2: 796.998,
    y2: 181.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_6_379",
    x1: 796.841,
    y1: 181.775,
    x2: 796.754,
    y2: 189.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_6_379",
    x1: 817.792,
    y1: 247.748,
    x2: 826.696,
    y2: 245.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_6_379",
    x1: 708.723,
    y1: 243.654,
    x2: 708.636,
    y2: 251.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_6_379",
    x1: 807.033,
    y1: 241.476,
    x2: 815.939,
    y2: 239.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_6_379",
    x1: 719.529,
    y1: 237.378,
    x2: 719.443,
    y2: 244.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_6_379",
    x1: 796.096,
    y1: 235.196,
    x2: 805,
    y2: 233.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_6_379",
    x1: 730.374,
    y1: 231.101,
    x2: 730.288,
    y2: 238.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_6_379",
    x1: 2211.55,
    y1: 220.335,
    x2: 2242.01,
    y2: 213.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_6_379",
    x1: 759.624,
    y1: 196.266,
    x2: 758.367,
    y2: 237.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_6_379",
    x1: 779.257,
    y1: 203.819,
    x2: 788.162,
    y2: 201.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_6_379",
    x1: 785.607,
    y1: 205.084,
    x2: 784.689,
    y2: 199.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_6_379",
    x1: 784.473,
    y1: 199.72,
    x2: 784.386,
    y2: 207.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_6_379",
    x1: 790.09,
    y1: 197.543,
    x2: 798.996,
    y2: 195.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_6_379",
    x1: 796.389,
    y1: 198.8,
    x2: 795.476,
    y2: 193.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_6_379",
    x1: 795.312,
    y1: 193.448,
    x2: 795.225,
    y2: 200.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_6_379",
    x1: 800.867,
    y1: 191.267,
    x2: 809.771,
    y2: 189.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_6_379",
    x1: 807.255,
    y1: 192.527,
    x2: 806.342,
    y2: 187.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_6_379",
    x1: 806.106,
    y1: 187.166,
    x2: 806.019,
    y2: 194.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_6_379",
    x1: 811.689,
    y1: 184.991,
    x2: 820.593,
    y2: 183.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_6_379",
    x1: 817.974,
    y1: 186.247,
    x2: 817.055,
    y2: 180.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_6_379",
    x1: 816.939,
    y1: 180.892,
    x2: 816.853,
    y2: 188.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_6_379",
    x1: 121.217,
    y1: 13.8915,
    x2: 278.359,
    y2: 59.3765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6973B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBDDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_6_379",
    x1: 220.449,
    y1: 25.9376,
    x2: 220.449,
    y2: 172.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AC3E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_6_379",
    x1: 781.46,
    y1: 23.0341,
    x2: 781.55,
    y2: 23.4233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515051"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_6_379",
    x1: -345.578,
    y1: 23.2481,
    x2: -260.894,
    y2: 152.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053F9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3084D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_6_379",
    x1: -264.44,
    y1: 154.932,
    x2: -388.856,
    y2: 110.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_6_379",
    x1: -255.549,
    y1: 78.806,
    x2: -355.138,
    y2: 143.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_6_379",
    x1: -224.113,
    y1: 223.507,
    x2: -224.113,
    y2: 142.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C8C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_6_379",
    x1: -224.117,
    y1: 126.663,
    x2: -224.117,
    y2: 109.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_6_379",
    x1: -225.383,
    y1: 72.6785,
    x2: -324.617,
    y2: 99.7711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053F9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3084D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_6_379",
    x1: 1719.53,
    y1: 795.374,
    x2: 1718.85,
    y2: 783.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053F9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3084D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_6_379",
    x1: 1728.43,
    y1: 807.343,
    x2: 1727.58,
    y2: 789.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#FFD712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_6_379",
    x1: 1726.42,
    y1: 799.728,
    x2: 1725.05,
    y2: 786.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#149648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#5ED91A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_6_379",
    x1: -254.071,
    y1: 108.951,
    x2: -234.138,
    y2: 108.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#FFD712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_6_379",
    x1: -348.037,
    y1: 574.803,
    x2: -344.229,
    y2: 574.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#FFD712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_6_379",
    x1: -342.259,
    y1: 574.822,
    x2: -338.453,
    y2: 574.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_6_379",
    x1: -337.028,
    y1: 574.801,
    x2: -333.22,
    y2: 574.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053F9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3084D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_6_379",
    x1: 1627.54,
    y1: 726.137,
    x2: 1642.57,
    y2: 726.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053F9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3084D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_6_379",
    x1: 1627.81,
    y1: 732.243,
    x2: 1650.54,
    y2: 732.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053F9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3084D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_6_379",
    x1: 1627.39,
    y1: 738.425,
    x2: 1656.12,
    y2: 738.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053F9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3084D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_6_379",
    x1: 1627.37,
    y1: 744.414,
    x2: 1660.92,
    y2: 744.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053F9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3084D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_6_379",
    x1: 1646.8,
    y1: 766.456,
    x2: 1656.28,
    y2: 766.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#FFD712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_6_379",
    x1: 1646.78,
    y1: 770.21,
    x2: 1661.11,
    y2: 770.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#FFD712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_6_379",
    x1: 1646.64,
    y1: 774.289,
    x2: 1664.76,
    y2: 774.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#FFD712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_6_379",
    x1: 1646.81,
    y1: 777.974,
    x2: 1667.96,
    y2: 777.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#FFD712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_6_379",
    x1: 1646.8,
    y1: 782.337,
    x2: 1656.28,
    y2: 782.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#149648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#5ED91A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_6_379",
    x1: 1646.78,
    y1: 785.917,
    x2: 1661.11,
    y2: 785.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#149648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#5ED91A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_6_379",
    x1: 1646.64,
    y1: 789.957,
    x2: 1664.76,
    y2: 789.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#149648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#5ED91A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_6_379",
    x1: 1646.65,
    y1: 793.718,
    x2: 1667.8,
    y2: 793.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#149648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#5ED91A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_6_379",
    x1: -1780.02,
    y1: 254.454,
    x2: -1825.3,
    y2: 199.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C89B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#FFC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC46E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_6_379",
    x1: -1802.67,
    y1: 165.813,
    x2: -1808.08,
    y2: 160.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8A94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#E29A3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_6_379",
    x1: -1854.16,
    y1: 121.828,
    x2: -1855.86,
    y2: 117.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B89B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#E29A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E29A3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_6_379",
    x1: -1795.2,
    y1: 168.194,
    x2: -1798.32,
    y2: 131.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BAEE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#61BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDEB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_6_379",
    x1: -1811.81,
    y1: 100.464,
    x2: -1790.98,
    y2: 221.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#DFDFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_6_379",
    x1: -1740.17,
    y1: 258.771,
    x2: -1753.25,
    y2: 258.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_6_379",
    x1: -1733.38,
    y1: 176.614,
    x2: -1819.65,
    y2: 43.2726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#DFDFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_6_379",
    x1: -1748.94,
    y1: 271.432,
    x2: -1760.39,
    y2: 271.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BAEE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#E29A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E29A3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_6_379",
    x1: 272.083,
    y1: 246.944,
    x2: 333.255,
    y2: 246.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#FFCF10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_6_379",
    x1: -1764.01,
    y1: 181.064,
    x2: -1863.33,
    y2: 198.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#FFC46E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 339,
    height: 333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataEntry);
export default __webpack_public_path__ + "static/media/data-entry.7abbe8768b0c619cd845a922382d03e4.svg";
export { ForwardRef as ReactComponent };